/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface BannerThemesTheme {
  backgroundColor: string
  titleColor: string
  bodyColor: string
  highlights: ThemeHighlight[]
}

/** @default "DEFAULT" */
export enum ItemUpsertExtraParamsSpecialMode {
  DEFAULT = "DEFAULT",
  M41 = "M41",
}

export interface M41MenuConfirmRequestitemWithM41Operation {
  item: FoodmaxapipbItemV2
  m41Operation: string
}

export interface M41MenuConfirmResponseFailedItems {
  itemIDs: string[]
}

export interface M41MenuConfirmResponseSucceedItems {
  itemIDs: string[]
}

export interface M41MenuPreviewResponseItemWithM41Info {
  item: FoodmaxapipbItemV2
  isM41: boolean
  discountPrice: string
  m41Status: string
  m41StatusContent: string
  m41StatusIconUrl: string
  displayDiscountPrice: string
  m41Source: string
  m41RelationShipItemID: string
}

export interface OrderV2Flags {
  showReceiptEaterAddress: boolean
  showForceCompleteButton: boolean
  hideOrderDriverInfo: boolean
  isPrintOrderRevampReceipt: boolean
  isGrabInitiatedSplitOrder: boolean
  isAdsMarketingAttributed: boolean
  isPaxNewCustomer: boolean
  isPayOnCollect: boolean
  /** @format int64 */
  merchantFeatureFlags: number
  isOPTPhase5Enabled: boolean
  isManualAcceptMode: boolean
  isM41Order: boolean
  isTH5050Order: boolean
  isCrossSell: boolean
}

export interface OutOfStockInstructionInstrumentation {
  /** preselectedInstructionType is the instruction type Grab preselects when Pax adds primary item to cart */
  preselectedInstructionType: string
  /** isInstructionTypeUserPreference indicates whether the instruction type was selected by Pax during past orders */
  isInstructionTypeUserPreference: boolean
  /**
   * initialPreferredItemIDs captures the item IDs from Pax's past orders when (preselectedInstructionType ==
   * "SPECIFIC_ITEM" and isInstructionTypeUserPreference == true)
   */
  initialPreferredItemIDs: string[]
  /**
   * initialRecommendedItemIDs captures the item IDs we recommended to Pax when (preselectedInstructionType ==
   * "SPECIFIC_ITEM")
   */
  initialRecommendedItemIDs: string[]
}

export interface OutletProfilePartner {
  qsr: string
  name: string
}

export interface SelfServeCampaignConfigAdsDescription {
  en: string
  id: string
  th: string
  vi: string
}

export interface ThemeHighlight {
  imageURL: string
  /** @format double */
  width: number
  /** @format double */
  height: number
  /** @format double */
  xAxisPosition: number
  /** @format double */
  yAxisPosition: number
}

export interface CartpbOutOfStockInstruction {
  title: string
  instructionType: string
  hideInstruction: boolean
  replacementItemID: string
  replacementItems: CartpbReplacementItemInfo[]
  trailingIcon: string
  instrumentation: OutOfStockInstructionInstrumentation
  primaryItems: CartpbReplacementItemInfo[]
  icon: string
}

export interface CartpbReplacementItemInfo {
  itemID: string
  name: string
  /** @format int32 */
  quantity: number
  gtin: string
  photos: string[]
  /**
   * multiplier of primary item to replacement item
   * @format float
   */
  multiplier: number
  barcode: string
  SKU: string
  /** @format int64 */
  priceInMinorUnit: number
  unit: string
  /** @format float */
  value: number
  /** @format int64 */
  reducedPriceInMinorUnit: number
}

export interface CatalogpbAttribute {
  id: string
  name: string
  nameLocalization: string
  status: string
  attributeClusterID: string
  metadata: string
}

export interface CatalogpbAttributeCluster {
  id: string
  name: string
  nameLocalization: string
  businessType: string
  status: string
  icon: string
  attributeClusterType: string
  attributeClusterOption: CatalogpbAttributeClusterOption
  metadata: CatalogpbAttributeClusterMetadata
}

export interface CatalogpbAttributeClusterMap {
  attributeClusters: Record<string, CatalogpbAttributeCluster>
}

export interface CatalogpbAttributeClusterMetadata {
  preDefinedMetadata: CatalogpbPreDefinedMetadata
  booleanMetadata: CatalogpbBooleanMetadata
  decimalMetadata: CatalogpbDecimalMetadata
  freeTextMetadata: CatalogpbFreeTextMetadata
}

export interface CatalogpbAttributeClusterOption {
  /** @format int64 */
  countryID: number
  isMandatory: boolean
  isShownToPax: boolean
  isMexSelfServe: boolean
  isSearchKeywordEnabled: boolean
  isFilterOptionEnabled: boolean
  attributeClusterOptionID: string
}

export interface CatalogpbAttributesData {
  attributeClusters: Record<string, CatalogpbAttributeCluster>
  attributes: Record<string, CatalogpbAttribute>
}

export interface CatalogpbBooleanMetadata {
  defaultValue: boolean
}

/** ChannelConfig is the structure of one channel config */
export interface CatalogpbChannelConfig {
  key: string
  name: Record<string, string>
}

/** CharacteristicStrategy is the GrabX configuration structure for SOC display on the UI */
export interface CatalogpbCharacteristicStrategy {
  purchasableConfig: CatalogpbSOCConfig[]
  pricingConfig: CatalogpbSOCConfig[]
}

export interface CatalogpbDecimalMetadata {
  min: CatalogpbNilableInt32
  max: CatalogpbNilableInt32
  units: string
  numberOfDecimalPlaces: CatalogpbNilableInt32
  unitLocalization: string
}

export interface CatalogpbFreeTextMetadata {
  /** @format int32 */
  maxLength: number
}

export interface CatalogpbItemAttributeValueEnrichmentSignal {
  dataSource: string
  mappingMethod: string
  /** @format float */
  confidenceScore: number
  sourceRef: string
}

export interface CatalogpbItemAttributeValueMetadata {
  unit: string
  unitLocalization: string
  /** @format int32 */
  source: number
  /** @format double */
  score: number
  enrichmentSignal: CatalogpbItemAttributeValueEnrichmentSignal
}

export interface CatalogpbNilableInt32 {
  /** @format int32 */
  value: number
}

export interface CatalogpbPreDefinedMetadata {
  /** @format int32 */
  attributesLimitPerItem: number
}

/**
 * used only for service-based menu project by food-cms-api & food-max-api
 * different from the one at food/common/pb/cartpb/cart.proto:756
 */
export interface CatalogpbPricing {
  /** @format int64 */
  priceInMin: number
  priceDisplay: string
}

/** SOCConfig is the structure of one SOC config */
export interface CatalogpbSOCConfig {
  key: string
  name: Record<string, CatalogpbTranslation>
  channels: CatalogpbChannelConfig[]
}

export interface CatalogpbSupportedAttributeClusters {
  itemClassID: string
  attributeClusterIDs: string[]
}

/** Translation ... */
export interface CatalogpbTranslation {
  translation: Record<string, string>
}

export interface CommonpbCoordinates {
  /**
   * @inject_tag: obfuscate:"hide"
   * @format double
   */
  latitude: number
  /**
   * @inject_tag: obfuscate:"hide"
   * @format double
   */
  longitude: number
}

/** -----     specialOpeningHours  ----// */
export interface CommonpbHoursByDate {
  startDate: string
  endDate: string
  metadata: CommonpbMetadata
  openingHours: CommonpbHoursByDay
}

export interface CommonpbHoursByDay {
  periods: CommonpbTimePeriod[]
  openPeriodType: string
}

/** openingHours and serviceHours */
export interface CommonpbHoursByWeekDay {
  sun: CommonpbHoursByDay
  mon: CommonpbHoursByDay
  tue: CommonpbHoursByDay
  wed: CommonpbHoursByDay
  thu: CommonpbHoursByDay
  fri: CommonpbHoursByDay
  sat: CommonpbHoursByDay
}

export interface CommonpbMemberPriceInfo {
  ID: string
  /** @format int32 */
  quantity: number
  /** @format int64 */
  priceInMinorUnit: number
}

export interface CommonpbMetadata {
  description: string
  isDormant: boolean
  isIndefinitePause: boolean
  pauseCause: string
}

/** -----      tempPause       -----// */
export interface CommonpbTempPause {
  endDateTime: string
  metadata: CommonpbMetadata
}

export interface CommonpbTimePeriod {
  startTime: string
  endTime: string
}

export interface FoodmaxapipbAIGenerateItemContentBody {
  description: Record<string, string>
  detectedDescriptionLanguage: string
}

export interface FoodmaxapipbAIGenerateItemContentRequest {
  generateType: string
  payload: string
  regenerate: boolean
}

export interface FoodmaxapipbAIGenerateItemContentResponse {
  response: string
  responseID: string
  body: FoodmaxapipbAIGenerateItemContentBody
}

export interface FoodmaxapipbAcceptOrderEligibilityError {
  reasons: string[]
}

export interface FoodmaxapipbAcceptOrderV2Response {
  eligibilityError: FoodmaxapipbAcceptOrderEligibilityError
}

export interface FoodmaxapipbAction {
  scope: FoodmaxapipbMssScope
  actionType: FoodmaxapipbActionType
  /** @format float */
  discountValue: number
  /** @format float */
  discountCap: number
  discountValueDisplay: string
}

export interface FoodmaxapipbActionLabel {
  type: string
  label: string
}

/** @default "PROMOTION_TYPE_NET" */
export enum FoodmaxapipbActionType {
  PROMOTION_TYPE_NET = "PROMOTION_TYPE_NET",
  PROMOTION_TYPE_PERCENTAGE = "PROMOTION_TYPE_PERCENTAGE",
  PROMOTION_TYPE_DELIVERY = "PROMOTION_TYPE_DELIVERY",
  PROMOTION_TYPE_FREE_ITEM = "PROMOTION_TYPE_FREE_ITEM",
}

/** ActivateSelfServeCampaignRequest is the request object for ActivateSelfServeCampaign */
export interface FoodmaxapipbActivateSelfServeCampaignRequest {
  campaignID: string
}

export interface FoodmaxapipbAdvancedPricingConfig {
  /** @format int64 */
  maxPrice: number
  /** @format double */
  maxPriceDeviation: number
  /** @format double */
  maxPriceDifference: number
}

export interface FoodmaxapipbAttribute {
  id: string
  name: string
  nameLocalization: string
  /** @format int64 */
  countryID: number
  businessType: string
  status: string
  cluster: string
  attributeClusterID: string
}

export interface FoodmaxapipbAttributeContent {
  certificateDetails: FoodmaxapipbCertificateDetail[]
  rankScore: FoodmaxapipbAttributeRankScore
  isPreferred: FoodmaxapipbNilableBool
}

export interface FoodmaxapipbAttributeMeta {
  /** @format int32 */
  criteriaType: number
  isDocumentMandatory: boolean
  isExpiryMandatory: boolean
  /** @format int32 */
  selectionLimit: number
  iconURL: string
  localizedName: string
}

export interface FoodmaxapipbAttributePoolRules {
  /** @format int32 */
  countryID: number
  /** @format int32 */
  poolID: number
  attributeValues: FoodmaxapipbAttributeValue[]
  /** @format int32 */
  event: number
  /** @format int32 */
  selectionType: number
  isMandatory: boolean
}

export interface FoodmaxapipbAttributeRankScore {
  /** @format double */
  score: number
}

export interface FoodmaxapipbAttributeValue {
  /** @format int32 */
  attributeValueID: number
  /** @format int32 */
  poolID: number
  attributeValueName: string
  meta: FoodmaxapipbAttributeMeta
}

export interface FoodmaxapipbAutoCallSetting {
  autoCallCountryCode: string
  autoCallPhoneNumber: string
  isAutoCallEnabled: boolean
  callAgainAfterFailed: boolean
}

export interface FoodmaxapipbBCRSConfig {
  /** @format int32 */
  unitCountMin: number
  /** @format int32 */
  unitCountMax: number
}

export interface FoodmaxapipbBCRSConfirmAction {
  aiContentID: string
  entityID: string
  entityType: string
  action: string
  bcrsOverride: FoodmaxapipbBCRSInfo
}

export interface FoodmaxapipbBCRSConfirmResult {
  aiContentID: string
  entityID: string
  success: boolean
  errorMessage: string
}

export interface FoodmaxapipbBCRSInfo {
  eligible: boolean
  /** @format int32 */
  unitCount: number
  source: string
}

export interface FoodmaxapipbBCRSItemRecommendation {
  itemID: string
  itemName: string
  itemPhotoURL: string
  recommendedBcrsInfo: FoodmaxapipbBCRSRecommendedInfo
  entityType: string
  aiContentID: string
  /** Localized size text from item attribute "volume" cluster, e.g. "330ml". Empty if not set. */
  sizeText: string
  /**
   * Localized per-unit price string with currency symbol, e.g. "S$5.50". Falls back
   * to listing price when unitCount is 0/missing. Empty if PriceInMin is 0.
   */
  unitPriceDisplay: string
}

export interface FoodmaxapipbBCRSModifierGroupRecommendation {
  modifierGroupID: string
  modifierGroupName: string
  modifiers: FoodmaxapipbBCRSModifierRecommendation[]
}

export interface FoodmaxapipbBCRSModifierRecommendation {
  modifierID: string
  modifierName: string
  recommendedBcrsInfo: FoodmaxapipbBCRSRecommendedInfo
  entityType: string
  aiContentID: string
  /**
   * Localized per-unit price string with currency symbol, e.g. "S$5.50". Falls back
   * to modifier price when unitCount is 0/missing. Empty if PriceInMin is 0.
   */
  unitPriceDisplay: string
}

export interface FoodmaxapipbBCRSRecommendedInfo {
  eligible: boolean
  /** @format int32 */
  unitCount: number
  /** @format double */
  confidence: number
}

export interface FoodmaxapipbBank {
  bankName: string
  bankAccount: string
  bankHolderName: string
}

export interface FoodmaxapipbBannerCampaign {
  message: string
  themeColor: string
}

export interface FoodmaxapipbBannerThemes {
  genericThemes: BannerThemesTheme[]
  recommendedThemes: BannerThemesTheme[]
  /** @format int32 */
  dominantColors: number
}

export interface FoodmaxapipbBasketCondition {
  scope: FoodmaxapipbScope
  type: string
  /** @format float */
  value: number
}

/** @default "PROMOTION_CONDITION_AMOUNT" */
export enum FoodmaxapipbBasketConditionType {
  PROMOTION_CONDITION_AMOUNT = "PROMOTION_CONDITION_AMOUNT",
  PROMOTION_CONDITION_QUANTITY = "PROMOTION_CONDITION_QUANTITY",
}

export interface FoodmaxapipbBatchUpdateItemsSortOrderRequest {
  categorySorts: FoodmaxapipbCategorySortTo[]
}

export interface FoodmaxapipbBookingInOrderList {
  driver: FoodmaxapipbDriverInOrderList
  deliveryTaskpoolStatus: string
  /** @format date-time */
  deliveredAt: string
  /** @format date-time */
  busyModeOrderPickupTime: string
  /** @format date-time */
  driverArriveRestoAt: string
  shortOrderID: string
  itemInfo: FoodmaxapipbItemsInOrderList
  orderReadyPhotoDetail: FoodmaxapipbOrderReadyPhotoDetail
  miwiRisk: FoodmaxapipbMIWIRisk
}

export interface FoodmaxapipbBookingInOrderV2 {
  driver: FoodmaxapipbDriverInOrderV2
  deliveryTaskpoolStatus: string
  /** @format date-time */
  deliveredAt: string
  /** @format date-time */
  busyModeOrderPickupTime: string
  bookingCode: string
  shortOrderID: string
  items: FoodmaxapipbItemsInOrderV2
  preparationTaskID: string
  state: string
  /** @format date-time */
  completedAt: string
  /** @format date-time */
  cancelledAt: string
  /** @format date-time */
  readyAt: string
  preparationTaskpoolStatus: string
  isRead: boolean
  /** @format date-time */
  preparationCompletedAt: string
  isReadyButtonAbused: boolean
  orderReadyPhotoDetail: FoodmaxapipbOrderReadyPhotoDetail
  gisSubOrderID: string
  upcomingData: FoodmaxapipbUpcomingData
  displayHighlights: FoodmaxapipbDisplayHighlights
  recovery: FoodmaxapipbOrderRecovery
}

export interface FoodmaxapipbBudgetRange {
  /** @format double */
  minBid: number
  /** @format double */
  maxBid: number
  /** @format double */
  minSuggestedBid: number
}

/**
 * BulkConfirmBCRS: bulk accept / reject BCRS recommendations for items and
 * modifiers. Accept: merges bcrs into entity metadata + sets mex_confirmed=true.
 * Reject: sets is_hidden=true on the ai_generated_content row. Max 100 actions
 * per request.
 */
export interface FoodmaxapipbBulkConfirmBCRSRequest {
  merchantID: string
  actions: FoodmaxapipbBCRSConfirmAction[]
}

export interface FoodmaxapipbBulkConfirmBCRSResponse {
  /** @format int32 */
  totalCount: number
  /** @format int32 */
  successCount: number
  /** @format int32 */
  failedCount: number
  results: FoodmaxapipbBCRSConfirmResult[]
}

export interface FoodmaxapipbBundleOfferConfig {
  validDiscountTypes: string[]
}

export interface FoodmaxapipbBusinessAttribute {
  merchantID: string
  /** @format int32 */
  poolID: number
  /** @format int32 */
  attributeValueID: number
  /** @format int32 */
  eventSource: number
  /** @format int32 */
  attributeStatus: number
  content: FoodmaxapipbAttributeContent
}

export interface FoodmaxapipbCampaign {
  campaignID: string
  info: FoodmaxapipbCampaignInfo
  eventOptInfo: FoodmaxapipbCampaignEventOptInInfo
  performance: FoodmaxapipbCampaignOptInPerformance
}

export interface FoodmaxapipbCampaignConfig {
  /** @format date-time */
  startTime: string
  /** @format date-time */
  endTime: string
  quota: FoodmaxapipbQuota
  condition: FoodmaxapipbCondition
  discount: FoodmaxapipbDiscount
  scope: FoodmaxapipbScope
  /** @format int64 */
  cityID: number
  /** @format int64 */
  countryID: number
  countryCode: string
  dineInVoucher: FoodmaxapipbDineInVoucher
  name: string
  costPerOrder: FoodmaxapipbCostPerOrder
  campaignObjective: FoodmaxapipbCampaignObjective
}

export interface FoodmaxapipbCampaignEvent {
  eventID: string
  eventInfo: FoodmaxapipbCampaignEventInfo
}

export interface FoodmaxapipbCampaignEventActivityParams {
  eventID: string
  merchantID: string
  candidateItems: FoodmaxapipbCampaignEventItem[]
  quotas: FoodmaxapipbMerchantQuota
  optInPromotionInfos: FoodmaxapipbCampaignEventOptInPromotionInfo[]
}

export interface FoodmaxapipbCampaignEventActivityResult {
  success: boolean
  message: string
  code: string
}

export interface FoodmaxapipbCampaignEventAdditionalInfo {
  /** @format int32 */
  minSelectedItem: number
  /** @format int32 */
  maxSelectedItem: number
  itemTypeDescription: string
  eventDescription: string
  eventTermsAndConditions: string
  backgroundImageURL: string
  heroImageURL: string
  isCustomizedRedemptionAllowed: boolean
  /** @format int32 */
  minRedemptionLimit: number
  /** @format int32 */
  recommendedRedemptionLimit: number
  explorationImageURL: string
  infoGraphicURLs: string[]
}

export interface FoodmaxapipbCampaignEventGMSInfo {
  assets: FoodmaxapipbCampaignEventGMSInfoAsset[]
  paymentDesc: string
  paymentType: string
  isFullCapacity: boolean
  showLeaveCampaignButton: boolean
  packageInformationLink: string
}

export interface FoodmaxapipbCampaignEventGMSInfoAsset {
  name: string
  description: string
}

export interface FoodmaxapipbCampaignEventInfo {
  name: string
  /** @format date-time */
  startTime: string
  /** @format date-time */
  endTime: string
  /** @format date-time */
  registerStartTime: string
  /** @format date-time */
  registerEndTime: string
  /** @format int32 */
  eventType: number
  scope: FoodmaxapipbScope
  funding: FoodmaxapipbFunding
  condition: FoodmaxapipbCondition
  discount: FoodmaxapipbDiscount
  /** @format int32 */
  countryID: number
  /** @format int32 */
  cityID: number
  quota: FoodmaxapipbQuota
  additionInfo: FoodmaxapipbCampaignEventAdditionalInfo
  offerID: string
  gmsInfo: FoodmaxapipbCampaignEventGMSInfo
  targetItemType: string
  eligibleItems: string[]
  hasMultiplePromotions: boolean
  promotionInfos: FoodmaxapipbCampaignEventPromotionInfo[]
  /** @format int32 */
  minPromoSubmission: number
  /** @format int32 */
  maxPromoSubmission: number
}

export interface FoodmaxapipbCampaignEventInventory {
  /** @format int64 */
  orderAmountInMin: number
  /** @format int64 */
  orderCount: number
  /** @format int64 */
  mexTotalSpentInMin: number
  /** @format int64 */
  redemptionCount: number
}

export interface FoodmaxapipbCampaignEventItem {
  itemID: string
  itemName: string
}

export interface FoodmaxapipbCampaignEventOptInInfo {
  eventID: string
  /** @format int32 */
  eventType: number
  merchantID: string
  candidateItems: FoodmaxapipbCampaignEventItem[]
  /** @format int32 */
  optInStatus: number
  /** @format int32 */
  optOutOption: number
  promotionID: string
  promotionStatus: string
  /** @format date-time */
  terminationTime: string
  quotas: FoodmaxapipbMerchantQuota
  optInPromotionInfos: FoodmaxapipbCampaignEventOptInPromotionInfo[]
  eventPromotionIDs: FoodmaxapipbCampaignEventPromotionID[]
}

export interface FoodmaxapipbCampaignEventOptInPromotionInfo {
  eventPromotionInfoID: string
  candidateItems: FoodmaxapipbCampaignEventItem[]
}

export interface FoodmaxapipbCampaignEventPromotionID {
  eventPromotionInfoID: string
  promotionIDs: string[]
}

export interface FoodmaxapipbCampaignEventPromotionInfo {
  eventPromotionInfoID: string
  name: string
  conditions: FoodmaxapipbCondition
  customTags: Record<string, string>
  eligibleItemType: string
  eligibleItems: string[]
  /** @format int32 */
  minSelectedItem: number
  /** @format int32 */
  maxSelectedItem: number
  itemTypeDescription: string
  discount: FoodmaxapipbDiscount
  scope: FoodmaxapipbScope
}

export interface FoodmaxapipbCampaignInfo {
  /** @format date-time */
  startTime: string
  /** @format date-time */
  endTime: string
  /** @format date-time */
  endedTime: string
  quota: FoodmaxapipbQuota
  discount: FoodmaxapipbDiscount
  condition: FoodmaxapipbCondition
  scope: FoodmaxapipbScope
  /** @format int64 */
  countryID: number
  status: string
  name: string
  editableByMex: boolean
  /** @format int64 */
  authorType: number
  funding: FoodmaxapipbFunding
  eventID: string
  type: string
  gmsInfo: FoodmaxapipbCampaignEventGMSInfo
  /** @format int32 */
  merchantIDType: number
  itemSOCTypePriceRanges: FoodmaxapipbSOCTypePriceRanges[]
  bundleName: string
  costPerOrder: FoodmaxapipbCostPerOrder
  costPerOrderDisplay: string
}

export interface FoodmaxapipbCampaignMerchantEvent {
  eventID: string
  optInInfo: FoodmaxapipbCampaignEventOptInInfo
  eventInfo: FoodmaxapipbCampaignEventInfo
  isNew: boolean
}

export interface FoodmaxapipbCampaignObject {
  objectID: string
  objectName: string
}

/** @default "NONE" */
export enum FoodmaxapipbCampaignObjective {
  NONE = "NONE",
  DRIVE_SALES_ALL_CUSTOMER = "DRIVE_SALES_ALL_CUSTOMER",
  ATTRACT_NEW_CUSTOMER = "ATTRACT_NEW_CUSTOMER",
}

export interface FoodmaxapipbCampaignOptInPerformance {
  /** @format int32 */
  order: number
}

export interface FoodmaxapipbCampaignReport {
  ID: string
  /** @format double */
  merchantSpent: number
  /** @format double */
  roi: number
  /** @format double */
  incrementalSales: number
  /** @format int64 */
  incrementalOrders: number
  merchantSpentDisplay: string
  incrementalSalesDisplay: string
  /** @format int64 */
  clicks: number
}

export interface FoodmaxapipbCampaignSetting {
  itemLevel: string
  orderLevel: string
  freeItem: string
  deliveryFee: string
  serviceTypes: FoodmaxapipbServiceTypeInfo[]
}

export interface FoodmaxapipbCampaignStats {
  grossRevenueDisplay: string
  /** @format int64 */
  totalOrders: number
  /** @format int64 */
  totalRedemption: number
  /** @format int64 */
  totalRedemptionToday: number
  totalSpentDisplay: string
}

/** @default "CAMPAIGN_ANY" */
export enum FoodmaxapipbCampaignStatus {
  CAMPAIGN_ANY = "CAMPAIGN_ANY",
  CAMPAIGN_UPCOMING = "CAMPAIGN_UPCOMING",
  CAMPAIGN_ONGOING = "CAMPAIGN_ONGOING",
  CAMPAIGN_COMPLETED = "CAMPAIGN_COMPLETED",
}

export interface FoodmaxapipbCampaignTargetUser {
  userType: string
  userIDs: string[]
  publicVisible: boolean
  targetDesc: string
}

export interface FoodmaxapipbCampaignTime {
  /** @format date-time */
  startTime: string
  /** @format date-time */
  endTime: string
  allWeekdays: boolean
  allOpeningHours: boolean
  timeSlot: FoodmaxapipbTimeSlot
  weekDays: FoodmaxapipbWeekDays
  isAlwaysOn: boolean
}

export interface FoodmaxapipbCancelOrderRequest {
  orderID: string
  cancelReason: string
  /** @format int64 */
  cancelCode: number
}

export interface FoodmaxapipbCancelReason {
  /** @format int64 */
  cancelCode: number
  cancelReason: string
  cancelAction: string
}

export interface FoodmaxapipbCategory {
  ID: string
  name: string
  /** @format int64 */
  viewPerDay: number
}

export interface FoodmaxapipbCategoryReport {
  category: string
  /** @format double */
  merchantSpent: number
  /** @format double */
  incrementalSales: number
  /** @format int64 */
  incrementalOrders: number
  /** @format double */
  roi: number
  merchantSpentDisplay: string
  incrementalSalesDisplay: string
  /** @format int64 */
  clicks: number
}

export interface FoodmaxapipbCategorySortTo {
  categoryID: string
  itemSorts: FoodmaxapipbItemSortTo[]
}

export interface FoodmaxapipbCertificateDetail {
  certificateURL: string
  expireAt: string
  /** @format int32 */
  moderationStatus: number
  /** @format date-time */
  updatedTime: string
  rejectReasons: string[]
  hasExpired: boolean
}

export interface FoodmaxapipbChatHistory {
  /** @format date-time */
  chatTime: string
  type: string
  message: string
  action: string
  previewCards: FoodmaxapipbPreviewCard[]
}

export interface FoodmaxapipbChatroomInfo {
  roomID: string
  /** @format int64 */
  status: number
}

export interface FoodmaxapipbCheckForceLogoutResponse {
  forceLogout: boolean
}

export interface FoodmaxapipbCheckInMessage {
  title: string
  message: string
  bottomMessage: string
}

/** @default "NULL" */
export enum FoodmaxapipbCheckInOption {
  NULL = "NULL",
  YES = "YES",
  NO = "NO",
}

/** @default "BEFORE_OPEN" */
export enum FoodmaxapipbCheckInStage {
  BEFORE_OPEN = "BEFORE_OPEN",
  AROUND_OPEN = "AROUND_OPEN",
  AFTER_OPEN = "AFTER_OPEN",
}

/** @default "all" */
export enum FoodmaxapipbComboListType {
  All = "all",
  OrderMost = "order_most",
  Likely = "likely",
  Diversity = "diversity",
}

export interface FoodmaxapipbComponentRating {
  ratings: FoodmaxapipbRating[]
}

export interface FoodmaxapipbConcurrencyHandlingReleaseResponse {
  message: string
}

export interface FoodmaxapipbConcurrencyHandlingTryLockResponse {
  message: string
  /** @format int32 */
  optionType: number
  isEditingByOthers: boolean
}

export interface FoodmaxapipbCondition {
  /** @format int64 */
  minItemsCount: number
  minBasketAmountDisplay: string
  /** @format int32 */
  eaterType: number
  /** @format float */
  minBasketAmount: number
  workingDays: number[]
  workingHours: FoodmaxapipbTimeRange[]
  basketCondition: FoodmaxapipbBasketCondition[]
  /** @format int32 */
  paymentType: number
  serviceTypes: string[]
  orderTypes: string[]
  channelTypes: string[]
  targetUser: FoodmaxapipbCampaignTargetUser
  audienceTypes: string[]
  audienceTypesDisplay: string
}

export interface FoodmaxapipbContentBlock {
  title: FoodmaxapipbDisplayMessage
  subTitle: FoodmaxapipbDisplayMessage
}

export interface FoodmaxapipbCorrectOrderReadyTimeConfig {
  /** @format int32 */
  countdownStartTime: number
  /** @format int32 */
  step: number
  allowChangeAfterCountdown: boolean
  useNearbyStatusInOrder: boolean
  /**
   * When driver ETA is less than this value (in minutes), FE will show "Nearby" status.
   * This field is only relevant when using ETA to determine nearby status. Once we have moved to use the nearby status in order, it could be deprecated.
   * @format int32
   */
  nearbyThreshold: number
  /** @format int32 */
  mcorHideTimeout: number
  mcorExtendOptionsInMinutes: number[]
}

export interface FoodmaxapipbCorrectOrderReadyTimeInfo {
  supportMcor: boolean
  isEditable: boolean
  /** @format date-time */
  correctedOrderReadyAt: string
  /** @format date-time */
  estimatedOrderReadyAt: string
  driverCloseToPickingUp: boolean
  /** @format date-time */
  maxOrderReadyAt: string
}

export interface FoodmaxapipbCostPerClick {
  /** @format double */
  banner: number
  /** @format double */
  searchResults: number
  /** @format double */
  relevantCuisine: number
}

export interface FoodmaxapipbCostPerOrder {
  type: string
  /** @format float */
  value: number
}

export interface FoodmaxapipbCreateActiveSectionRequest {
  sectionToCreate: FoodmaxapipbSection
  sectionsToUpdate: FoodmaxapipbSection[]
}

export interface FoodmaxapipbCreateActiveSectionResponse {
  sectionID: string
}

export interface FoodmaxapipbCreateAssistantChatRequest {
  chatID: string
  message: string
}

export interface FoodmaxapipbCreateAssistantChatResponse {
  action: string
  messages: string[]
  previewCards: FoodmaxapipbPreviewCard[]
  sessionID: string
  tips: string[]
}

export interface FoodmaxapipbCreateCampaignRequest {
  config: FoodmaxapipbCampaignConfig
  preCheck: boolean
}

export interface FoodmaxapipbCreateCampaignResponse {
  campaignID: string
  serviceTypePriceRange: Record<string, string>
}

export interface FoodmaxapipbCreateCategoryRequest {
  name: string
  sectionID: string
  sellingTimeID: string
  nameTranslation: FoodmaxapipbNilableTranslation
}

export interface FoodmaxapipbCreateCategoryResponse {
  categoryID: string
}

export interface FoodmaxapipbCreateDispatchRequest {
  orderID: string
  schedule: FoodmaxapipbDispatchSchedule
  deliveryFee: string
}

export interface FoodmaxapipbCreateDispatchResponse {
  message: string
  deliveryFee: string
}

export interface FoodmaxapipbCreateItemRequest {
  item: FoodmaxapipbItemV2
  categoryID: string
}

export interface FoodmaxapipbCreateItemResponse {
  itemID: string
}

export interface FoodmaxapipbCreateMenuGroupActiveSectionRequest {
  sectionToCreate: FoodmaxapipbMenuGroupSection
  sectionsToUpdate: FoodmaxapipbMenuGroupSection[]
  menuGroupID: string
}

export interface FoodmaxapipbCreateMenuGroupCategoryRequest {
  menuGroupID: string
  name: string
  sectionID: string
  sellingTimeID: string
  nameTranslation: FoodmaxapipbNilableTranslation
}

export interface FoodmaxapipbCreateMenuGroupCategoryResponse {
  categoryID: string
}

export interface FoodmaxapipbCreateMenuGroupItemModifierGroupLinkRequest {
  menuGroupID: string
  itemID: string
  modifierGroupID: string
}

export interface FoodmaxapipbCreateMenuGroupItemRequest {
  menuGroupID: string
  item: FoodmaxapipbItemV2
  categoryID: string
}

export interface FoodmaxapipbCreateMenuGroupItemResponse {
  itemID: string
}

export interface FoodmaxapipbCreateMenuGroupModifierGroupRequest {
  menuGroupID: string
  modifierGroup: FoodmaxapipbModifierGroup
}

export interface FoodmaxapipbCreateMenuGroupModifierGroupResponse {
  modifierGroupID: string
}

export interface FoodmaxapipbCreateMenuGroupRequest {
  menuGroup: FoodmaxapipbMenuGroup
  menuGroupID: string
  linkedStoreIDs: string[]
}

export interface FoodmaxapipbCreateMenuGroupResponse {
  menuGroupID: string
}

export interface FoodmaxapipbCreateModifierGroupRequest {
  modifierGroup: FoodmaxapipbModifierGroup
}

export interface FoodmaxapipbCreateModifierGroupResponse {
  modifierGroupID: string
}

export interface FoodmaxapipbCreatePasscodeRequest {
  passcode: string
}

export interface FoodmaxapipbCreatePasscodeResponse {
  token: string
  /** @format int32 */
  tokenExpireInSec: number
}

export interface FoodmaxapipbCreateReviewReplyResponse {
  replyID: string
}

/** CreateSelfServeCampaignRequest is the request object for CreateSelfServeCampaign */
export interface FoodmaxapipbCreateSelfServeCampaignRequest {
  isActive: boolean
  campaignType: FoodmaxapipbSelfServeCampaignType
  foodPromotionID: string
  segmentType: FoodmaxapipbSegmentType
  imageURL: string
  /** @format double */
  budget: number
  /** @format double */
  costPerClick: number
  campaignTime: FoodmaxapipbCampaignTime
  relevantCuisineCampaign: FoodmaxapipbRelevantCuisineCampaign
  searchCampaign: FoodmaxapipbSearchCampaign
  bannerCampaign: FoodmaxapipbBannerCampaign
  campaignID: string
  cta: string
  headline: string
  advertiserName: string
  images: FoodmaxapipbImageAsset[]
  isSmartBid: boolean
}

/** CreateSelfServeCampaign is the response object for CreateSelfServeCampaign */
export interface FoodmaxapipbCreateSelfServeCampaignResponse {
  campaignID: string
  isActive: boolean
  type: FoodmaxapipbSelfServeCampaignType
  foodPromotionID: string
  segmentType: FoodmaxapipbSegmentType
  imageURL: string
  /** @format double */
  budget: number
  /** @format double */
  costPerClick: number
  campaignTime: FoodmaxapipbCampaignTime
  relevantCuisineCampaign: FoodmaxapipbRelevantCuisineCampaign
  searchCampaign: FoodmaxapipbSearchCampaign
  bannerCampaign: FoodmaxapipbBannerCampaign
  cta: string
  headline: string
  advertiserName: string
  images: FoodmaxapipbImageAsset[]
  isSmartBid: boolean
}

export interface FoodmaxapipbCreateSellingTimeResponse {
  sellingTimeID: string
}

export interface FoodmaxapipbCuisinePageLocalizeContent {
  header: string
  subtitle: string
}

export interface FoodmaxapipbCurrency {
  code: string
  symbol: string
  exponent: string
  /** @format int64 */
  exponentUnit: number
}

export interface FoodmaxapipbDOButtonSegment {
  type: string
  buttonColor: string
  actionType: string
  actionUrl: string
}

export interface FoodmaxapipbDOChecklistSection {
  type: string
  title: string
  description: string
  status: string
  isDefaultExpanded: boolean
  contentSegments: FoodmaxapipbDOContentSegment[]
  buttonSegments: FoodmaxapipbDOButtonSegment[]
  statusIconUrl: string
  sectionName: string
  bottomSheetTitle: string
  bottomSheetSubtitle: string
  /** @format int32 */
  minimumImageCount: number
  /** @format int32 */
  maximumImageCount: number
  shouldReview: boolean
}

export interface FoodmaxapipbDOContentSegment {
  type: string
  label: string
  images: FoodmaxapipbDOImageItem[]
  keyValues: FoodmaxapipbDOKeyValueItem[]
  labelIconUrl: string
  businessImageType: string
  businessDisplayType: string
}

export interface FoodmaxapipbDOImageItem {
  url: string
  thumbnailUrl: string
  isSelected: boolean
  moderationStatus: string
  moderationReason: string
}

export interface FoodmaxapipbDOKeyValueDataItem {
  key: string
  value: string
}

export interface FoodmaxapipbDOKeyValueItem {
  title: string
  kvData: FoodmaxapipbDOKeyValueDataItem[]
}

export interface FoodmaxapipbDailyStatement {
  date: string
  /** @format int64 */
  orderNums: number
  currency: FoodmaxapipbCurrency
  /** @format int64 */
  dailyFareInMinorUnit: number
  priceDisplay: string
}

export interface FoodmaxapipbDayReport {
  /** @format date-time */
  date: string
  /** @format double */
  merchantSpent: number
  /** @format double */
  incrementalSales: number
  /** @format int64 */
  incrementalOrders: number
  /** @format double */
  roi: number
  merchantSpentDisplay: string
  incrementalSalesDisplay: string
  /** @format int64 */
  clicks: number
}

/** DeactivateSelfServeCampaignRequest is the request object for DeactivateSelfServeCampaign */
export interface FoodmaxapipbDeactivateSelfServeCampaignRequest {
  campaignID: string
}

export interface FoodmaxapipbDefaultMessage {
  cta: string
  headline: string
  message: string
}

export interface FoodmaxapipbDeleteItemRequest {
  itemID: string
  itemIDs: string[]
  categoryIDs: string[]
  departmentIDs: string[]
  subDepartmentIDs: string[]
  excludedSubDepartmentIDs: string[]
  excludedItemIDs: string[]
}

export interface FoodmaxapipbDeleteMenuGroupItemModifierGroupLinkRequest {
  menuGroupID: string
  itemID: string
  modifierGroupID: string
}

export interface FoodmaxapipbDeleteMenuGroupRequest {
  menuGroupID: string
}

export interface FoodmaxapipbDetailedDescription {
  title: string
  subtitle: string
  terms: string[]
}

export interface FoodmaxapipbDetection {
  taskID: string
  errorItems: string[]
  warningItems: string[]
}

export interface FoodmaxapipbDineInInfo {
  tableID: string
  /** @format int64 */
  eaterCount: number
}

export interface FoodmaxapipbDineInReviewConfig {
  enableShowDineInReviewIsHiddenBanner: boolean
  /** @format int32 */
  ListDineInReviewMaxMonthCount: number
}

export interface FoodmaxapipbDineInVoucher {
  detailedDescription: Record<string, FoodmaxapipbDetailedDescription>
  iconURL: string
  heroURL: string
  availableHours: CommonpbHoursByWeekDay
  /** @format int32 */
  fundingDurationInDays: number
  funding: FoodmaxapipbFunding
}

export interface FoodmaxapipbDineInVoucherConfig {
  /** @format int32 */
  termsMaxLimit: number
  /** @format int32 */
  termMaxLength: number
  /** @format int32 */
  dineInVoucherMaxDayCount: number
  /** @format int32 */
  titleMaxLength: number
  /** @format int32 */
  subTitleMaxLength: number
  /** @format int32 */
  redemptionLogSize: number
  /** @format int32 */
  maxUploadPhotos: number
}

export interface FoodmaxapipbDineInVoucherDetailedInfo {
  campaignID: string
  currency: FoodmaxapipbCurrency
  /** @format date-time */
  startTime: string
  /** @format date-time */
  endTime: string
  /** @format int64 */
  totalRedemption: number
  /** @format int64 */
  totalRedemptionPerUser: number
  /** @format int64 */
  cityID: number
  /** @format int64 */
  countryID: number
  countryCode: string
  detailedDescription: Record<string, FoodmaxapipbDetailedDescription>
  iconURL: string
  heroURL: string
  /** @format int32 */
  totalInventory: number
  /** @format float */
  minBasketAmount: number
  status: string
  availableHours: CommonpbHoursByWeekDay
  merchantID: string
  isZeusAuthorType: boolean
  isInstantDeal: boolean
  maxDiscountCapDisplay: string
  audienceTypes: string
  discount: FoodmaxapipbDiscount
  isCoFunded: boolean
  /** @format float */
  commissionRate: number
  trialCommission: FoodmaxapipbTrialCommission
}

export interface FoodmaxapipbDiscardMenuSuggestionRequest {
  entityType: string
  entityID: string
  suggestionType: string
}

export interface FoodmaxapipbDiscount {
  type: string
  discountValueDisplay: string
  discountCapDisplay: string
  /** @format float */
  discountValue: number
  /** @format float */
  discountCap: number
  /** @format int32 */
  bundleQuantity: number
  customDiscountDisplay: string
}

export interface FoodmaxapipbDiscountHygiene {
  /** @format float */
  AbsoluteMin: number
  /** @format float */
  AbsoluteMax: number
  /** @format float */
  PercentageMin: number
  /** @format float */
  PercentageMax: number
  /** @format float */
  StepAmount: number
  /** @format int32 */
  BundleQtyMin: number
  /** @format int32 */
  BundleQtyMax: number
  /** @format float */
  ItemPriceMin: number
}

export interface FoodmaxapipbDishPhotoForMex {
  dishPhotoID: string
  dishPhotoName: string
  score: string
  dishPhotoUrl: string
  dishPhotoWebpUrl: string
}

export interface FoodmaxapipbDispatchSchedule {
  /** @format date-time */
  pickupTimeFrom: string
  /** @format date-time */
  pickupTimeTo: string
}

export interface FoodmaxapipbDisplayHighlights {
  highlightItemCount: boolean
  missingItemIDs: string[]
  highMIWIRisk: boolean
  highMIWIRiskItemIDs: string[]
}

export interface FoodmaxapipbDisplayMessage {
  plainText: string
  html: string
}

export interface FoodmaxapipbDriverInOrder {
  /** @format int64 */
  ID: number
  name: string
  avatar: string
  mobileNumber: string
  /** @format float */
  latitude: number
  /** @format float */
  longitude: number
  plateNumber: string
  vehicleType: string
  vehicleModel: string
}

export interface FoodmaxapipbDriverInOrderList {
  /** @format int64 */
  ID: number
  name: string
  avatar: string
}

export interface FoodmaxapipbDriverInOrderV2 {
  name: string
  mobileNumber: string
  /** @format float */
  latitude: number
  /** @format float */
  longitude: number
  location: FoodmaxapipbLocationInDriverInOrderV2
  avatar: string
}

export interface FoodmaxapipbDynamicBidding {
  banner: FoodmaxapipbBudgetRange
  searchResults: FoodmaxapipbBudgetRange
  relevantCuisine: FoodmaxapipbBudgetRange
}

export interface FoodmaxapipbEInvoiceCarrierDisplay {
  displayLabel: string
  textValue: string
  barcodeString: string
  barcodeFormat: string
}

export interface FoodmaxapipbEInvoiceCarrierItemBreakdown {
  itemID: string
  name: string
  /** @format int64 */
  price: number
  displayPrice: string
  /** @format int32 */
  quantity: number
  /** @format int64 */
  totalPrice: number
  displayTotalPrice: string
  otherPrices: FoodmaxapipbEInvoiceCarrierItemBreakdownOtherPrice[]
}

export interface FoodmaxapipbEInvoiceCarrierItemBreakdownOtherPrice {
  title: string
  value: string
}

export interface FoodmaxapipbEInvoiceCarrierMemberBreakdown {
  memberID: string
  paxID: string
  paxName: string
  isHost: boolean
  /** @format int64 */
  totalPrice: number
  displayTotalPrice: string
  eInvoiceCarrierDisplay: FoodmaxapipbEInvoiceCarrierDisplay
  items: FoodmaxapipbEInvoiceCarrierItemBreakdown[]
  otherPrices: FoodmaxapipbEInvoiceCarrierItemBreakdownOtherPrice[]
}

export interface FoodmaxapipbEInvoiceCarrierSection {
  title: string
  memberBreakdowns: FoodmaxapipbEInvoiceCarrierMemberBreakdown[]
}

export interface FoodmaxapipbEaterInOrder {
  /** @format int64 */
  ID: number
  name: string
  avatar: string
  mobileNumber: string
  address: string
  /** @format float */
  latitude: number
  /** @format float */
  longitude: number
  comment: string
}

export interface FoodmaxapipbEaterInOrderList {
  /** @format int64 */
  ID: number
  name: string
}

export interface FoodmaxapipbEaterInOrderV2 {
  name: string
  mobileNumber: string
  comment: string
  address: FoodmaxapipbPlaceInEaterOrderV2
}

export interface FoodmaxapipbEditedItemInfo {
  itemID: string
  itemName: string
  /** @format int32 */
  quantity: number
  /** @format int64 */
  priceInMin: number
  /** @format int64 */
  status: number
  modifierGroups: FoodmaxapipbEditedModifierGroupInfo[]
  /** @format float */
  adjustedWeight: number
  /** @format int64 */
  originalIndex: number
  itemKey: string
  comment: string
  outOfStockInstruction: CartpbOutOfStockInstruction
  paxTranslation: Record<string, string>
}

export interface FoodmaxapipbEditedModifierGroupInfo {
  modifierGroupID: string
  modifierGroupName: string
  modifiers: FoodmaxapipbEditedModifierInfo[]
}

export interface FoodmaxapipbEditedModifierInfo {
  modifierID: string
  modifierName: string
  /** @format int32 */
  quantity: number
  /** @format int64 */
  priceInMin: number
  /** @format int64 */
  status: number
}

export interface FoodmaxapipbEnhanceImageRequest {
  image: string
  task: FoodmaxapipbEnhanceTask
}

export interface FoodmaxapipbEnhanceImageResponse {
  image: string
  processedTasks: FoodmaxapipbEnhanceTask[]
}

/**
 * - AUTO_ENHANCE: composite with issue detection
 * @default "DEBLUR"
 */
export enum FoodmaxapipbEnhanceTask {
  DEBLUR = "DEBLUR",
  SUPER_RESOLUTION = "SUPER_RESOLUTION",
  BACKGROUND_REMOVAL = "BACKGROUND_REMOVAL",
  CONTRAST_BRIGHTNESS = "CONTRAST_BRIGHTNESS",
  DETECTION = "DETECTION",
  AUTO_ENHANCE = "AUTO_ENHANCE",
  AUTO_ENHANCE_BACKGROUND_REMOVAL = "AUTO_ENHANCE_BACKGROUND_REMOVAL",
  AUTO_BACKGROUND_REMOVAL = "AUTO_BACKGROUND_REMOVAL",
}

/** @default "unspecifiedEntity" */
export enum FoodmaxapipbEntityType {
  UnspecifiedEntity = "unspecifiedEntity",
  Category = "category",
  Department = "department",
  SubDepartment = "subDepartment",
}

export interface FoodmaxapipbExportBulkTemplateResponse {
  template: string
  entities: FoodmaxapipbMenuEntity[]
}

export interface FoodmaxapipbExportReviewListRequest {
  /** @format date-time */
  startDate: string
  /** @format date-time */
  endDate: string
  rating: number[]
  status: FoodmaxapipbReviewStatus[]
  serviceType: string
  replyFilter: string
  merchantIDs: string[]
  /** @format int32 */
  businessTypeFilter: number
  orderBy: string
  asc: boolean
}

export interface FoodmaxapipbExportReviewListResponse {
  taskID: string
}

export interface FoodmaxapipbExtendCampaignRequest {
  campaignID: string
  /** @format date-time */
  extendEndTime: string
  /** @format date-time */
  currentEndTime: string
}

export interface FoodmaxapipbFEConfig {
  reviewReportConfig: FoodmaxapipbReviewReportConfig
  serviceBasedMenuConfig: FoodmaxapipbServiceBasedMenuConfig
  mcorConfig: FoodmaxapipbCorrectOrderReadyTimeConfig
  socLocalization: Record<string, FoodmaxapipbSOCTypeTranslation>
  reviewReplyConfig: FoodmaxapipbReviewReplyConfig
  bundleOfferConfig: FoodmaxapipbBundleOfferConfig
  dineInVoucherConfig: FoodmaxapipbDineInVoucherConfig
  dineInReviewConfig: FoodmaxapipbDineInReviewConfig
  /** @format int32 */
  orderStatusPollInterval: number
  orderMarkReadyConfig: FoodmaxapipbOrderMarkReadyConfig
  menuValidationConfig: FoodmaxapipbMenuValidationConfig
}

export interface FoodmaxapipbFailedOrder {
  orderID: string
  reason: string
}

export interface FoodmaxapipbFailedPhoto {
  imageURL: string
  reasons: string[]
  reasonMessages: string[]
  appealLink: string
  removedAt: string
}

export interface FoodmaxapipbFareInOrder {
  currencyCode: string
  currencySymbol: string
  currencyExponent: string
  /** @format int64 */
  currencyExponentUnit: number
  /** @format int64 */
  totalInCent: number
  /** @format int64 */
  subTotalInCent: number
  /** @format int64 */
  taxInCent: number
  /** @format int64 */
  adjustmentByDriverInCent: number
  totalDisplay: string
  subTotalDisplay: string
  taxDisplay: string
  adjustmentByDriverDisplay: string
}

export interface FoodmaxapipbFareInOrderV2 {
  currencySymbol: string
  /** @format int64 */
  totalInCent: number
  /** @format int64 */
  adjustmentByDriverInCent: number
  totalDisplay: string
  subTotalDisplay: string
  taxDisplay: string
  adjustmentByDriverDisplay: string
  promotionDisplay: string
  deliveryFeeDisplay: string
  passengerTotalDisplay: string
  totalDiscountAmountDisplay: string
  reducedPriceDisplay: string
  revampedSubtotalDisplay: string
  cancelledDisplay: string
  taxRate: string
  merchantChargeDisplay: string
  isIncludeMerchantChargeTax: boolean
  subtotalIncludeMerchantCharge: string
  chargeFeeDescription: Record<string, string>
  smallOrderFeeDisplay: string
  serviceChargeFeeDisplay: string
  serviceChargeFeeDescription: Record<string, string>
  daxPayMexFareDisplay: string
  mexCommissionDisplay: string
  onBehalfWithholdTaxDisplay: string
  mexVatAmountDisplay: string
  mexPitAmountDisplay: string
  /** @format int64 */
  originalPriceInMin: number
  bcrsDepositDisplay: string
  /** @format int64 */
  bcrsDepositInCent: number
  /** @format int32 */
  bcrsDepositItemCount: number
}

export interface FoodmaxapipbFeedbackOverview {
  /** @format double */
  aggregatedRatingScore: number
  /** @format int64 */
  ratingCount: number
  ratingDistribution: FoodmaxapipbRatingDistribution[]
  leaveAReviewEntryPointDeeplink: string
  componentRating: FoodmaxapipbComponentRating
  minMaxRatingDetails: FoodmaxapipbMinMaxRatingDetails
}

export interface FoodmaxapipbFestivePromptContent {
  title: string
  content: string
  actionLabels: FoodmaxapipbActionLabel[]
  festiveImageUrl: string
}

export interface FoodmaxapipbFileInfo {
  name: string
  type: string
  /** @format int64 */
  size: number
  data: string
}

/**
 * FpPostSync carries the post-migration full-sync warning for a FoodPanda -> Grab migrated merchant.
 * Absence of this object is the contractual "not applicable" signal; the client renders nothing.
 */
export interface FoodmaxapipbFpPostSync {
  /** enableTopUp reports whether the merchant may still top up before the full re-sync runs. */
  enableTopUp: boolean
  /**
   * fullSyncDate is the PRE-LOCALISED display string for the request's language, resolved server side.
   * It is never a machine-readable date - the client only ever renders it.
   */
  fullSyncDate: string
}

export interface FoodmaxapipbFunding {
  /** @format int32 */
  mex: number
  /** @format int32 */
  grab: number
}

export interface FoodmaxapipbGetAppUpdateVersionResponse {
  forceUpdateVer: FoodmaxapipbUpdateVersionInfo
  softUpdateVer: FoodmaxapipbUpdateVersionInfo
}

export interface FoodmaxapipbGetAssistantChatStatusResponse {
  sessionID: string
  chatHistory: FoodmaxapipbChatHistory[]
  tips: string[]
  welcomeMessage: string
  disclaimer: string
}

export interface FoodmaxapipbGetAttributePoolRulesResponse {
  rule: FoodmaxapipbAttributePoolRules[]
}

export interface FoodmaxapipbGetBCRSRecommendationsResponse {
  title: string
  description: string
  learnMore: FoodmaxapipbLearnMoreInfo
  items: FoodmaxapipbBCRSItemRecommendation[]
  modifierGroups: FoodmaxapipbBCRSModifierGroupRecommendation[]
  /** @format int32 */
  totalItemCount: number
  /** @format int32 */
  totalModifierCount: number
  /** @format int32 */
  limit: number
  /** @format int32 */
  offset: number
}

/** GetBannerCampaignDefaultMessagesResponse is the response object for GetBannerCampaignDefaultMessages */
export interface FoodmaxapipbGetBannerCampaignDefaultMessagesResponse {
  messages: string[]
  defaultMessages: FoodmaxapipbDefaultMessage[]
  promotionMessages: FoodmaxapipbPromotionMessage[]
}

export interface FoodmaxapipbGetBusinessAttributesBResponse {
  businessAttributeValues: FoodmaxapipbBusinessAttribute[]
}

export interface FoodmaxapipbGetBusinessAttributesV2Response {
  merchantAttributes: FoodmaxapipbMerchantAttributes[]
}

/** GetCampaignAdhocReport is the response object for GetCampaignAdhocReport */
export interface FoodmaxapipbGetCampaignAdhocReportResponse {
  selfServeAdhocReport: FoodmaxapipbSelfServeAdhocReport
}

export interface FoodmaxapipbGetCampaignEventByEventIDAndMerchantIDResponse {
  merchantEvent: FoodmaxapipbCampaignMerchantEvent
  inventory: FoodmaxapipbCampaignEventInventory
}

export interface FoodmaxapipbGetCampaignEventByEventIDResponse {
  event: FoodmaxapipbCampaignEvent
}

export interface FoodmaxapipbGetCampaignPerformanceOverall {
  /** @format int64 */
  totalOrders: number
  /** @format float */
  totalSales: number
  /** @format float */
  totalSpent: number
  currency: string
}

export interface FoodmaxapipbGetCampaignPerformanceResponse {
  overall: FoodmaxapipbGetCampaignPerformanceOverall
  trend: FoodmaxapipbGetCampaignPerformanceTrend[]
}

export interface FoodmaxapipbGetCampaignPerformanceTrend {
  date: string
  /** @format float */
  value: number
  displayValue: string
}

export interface FoodmaxapipbGetCampaignResponse {
  campaignID: string
  stats: FoodmaxapipbCampaignStats
  currency: FoodmaxapipbCurrency
}

/** GetCampaignsAdhocSummaryReport is the response object for GetCampaignsAdhocSummaryReport */
export interface FoodmaxapipbGetCampaignsAdhocSummaryReportResponse {
  campaignReports: FoodmaxapipbCampaignReport[]
}

export interface FoodmaxapipbGetConciergeOrdersResponse {
  orders: FoodmaxapipbSimpleOrder[]
  merchantModel: string
}

export interface FoodmaxapipbGetDeliveringOrdersResponse {
  orders: FoodmaxapipbSimpleOrderV2[]
}

export interface FoodmaxapipbGetDineInCampaignResponse {
  dineInVoucherDetailedInfo: FoodmaxapipbDineInVoucherDetailedInfo
}

export interface FoodmaxapipbGetDineoutChecklistResponse {
  /** @format int32 */
  readinessScore: number
  checklistPageTitle: string
  checklistPageImageUrl: string
  sections: FoodmaxapipbDOChecklistSection[]
  checklistPageScoreTitle: string
  checklistPageScoreSubtitle: string
  checklistPageScoreInlineSubtitle: string
  readinessScoreColor: string
  /** @format int32 */
  sectionCount: number
  checklistPageScoreInlineTitle: string
  checklistPageScoreInlineButtonText: string
}

export interface FoodmaxapipbGetDineoutListingPhotosResponse {
  photos: FoodmaxapipbPhotoDetail[]
}

export interface FoodmaxapipbGetDineoutPhotosResponse {
  photos: FoodmaxapipbPhotoDetail[]
}

export interface FoodmaxapipbGetDynamicRenderResponse {
  needUpdate: boolean
  needFallback: boolean
  url: string
  md5: string
  /** @format int64 */
  versionCode: number
}

export interface FoodmaxapipbGetEventOptions {
  merchantID: string
}

export interface FoodmaxapipbGetExportReviewListResultRequest {
  taskID: string
}

export interface FoodmaxapipbGetExportReviewListResultResponse {
  url: string
}

export interface FoodmaxapipbGetFEConfigResponse {
  config: FoodmaxapipbFEConfig
}

export interface FoodmaxapipbGetFeedbackOverviewResponse {
  feedbackOverview: FoodmaxapipbFeedbackOverview
}

export interface FoodmaxapipbGetHierarchyDetailsByHierarchyIDsResponse {
  hierarchies: FoodmaxapipbHierarchyEntity[]
}

export interface FoodmaxapipbGetIncidentResponse {
  incident: FoodmaxapipbmavIncident
  activity: FoodmaxapipbmavActivity
}

export interface FoodmaxapipbGetIncidentStatsResponse {
  ticketStats: FoodmaxapipbmavTicketStats
}

export interface FoodmaxapipbGetItemDepartmentSuggestionsResponse {
  predictionID: string
  suggestedDepartments: FoodmaxapipbSuggestedDepartment[]
}

export interface FoodmaxapipbGetItemDetailsByItemIDsResponse {
  items: FoodmaxapipbItemV2[]
  modifierGroups: FoodmaxapipbModifierGroup[]
}

export interface FoodmaxapipbGetItemPredictionResponse {
  predictions: FoodmaxapipbPredictions
  price_recommendation: FoodmaxapipbPriceRecommendation
}

export interface FoodmaxapipbGetLogoImagePhotosResponse {
  photos: FoodmaxapipbPhotoDetail[]
}

export interface FoodmaxapipbGetMenuCopilotSuggestionsResponse {
  itemSuggestions: FoodmaxapipbMenuItemSuggestion[]
  /** @format int64 */
  totalItemCount: number
}

export interface FoodmaxapipbGetMenuGroupItemPredictionResponse {
  predictions: FoodmaxapipbPredictions
  price_recommendation: FoodmaxapipbPriceRecommendation
}

export interface FoodmaxapipbGetMenuGroupResponse {
  menuGroup: FoodmaxapipbMenuGroup
  serviceBasedMenuConfig: FoodmaxapipbServiceBasedMenuConfig
}

export interface FoodmaxapipbGetMenuGroupSellingTimeResponse {
  sellingTime: FoodmaxapipbMenuGroupSellingTime
}

export interface FoodmaxapipbGetMenuGroupSupportedAttributeClustersResponse {
  supportedAttributeClusters: CatalogpbSupportedAttributeClusters[]
  supportedAttributeClusterMap: CatalogpbAttributeClusterMap
}

export interface FoodmaxapipbGetMenuGroupTranslationRequest {
  textType: string
  entity: string
  text: string
  textSourceLang: string
  textTargetLang: string[]
  menuGroupID: string
}

export interface FoodmaxapipbGetMenuGroupTranslationResponse {
  textTranslation: Record<string, string>
  metadata: Record<string, FoodmaxapipbTranslationMetadata>
}

export interface FoodmaxapipbGetMenuInsightsComboListResponse {
  result: FoodmaxapipbMenuInsightsCombo[]
}

export interface FoodmaxapipbGetMenuInsightsContextualNudgesResponse {
  shouldShow: boolean
}

export interface FoodmaxapipbGetMenuInsightsItemTrendingResponse {
  result: FoodmaxapipbMenuInsightsItemTrending[]
}

export interface FoodmaxapipbGetMenuInsightsItemsResponse {
  result: FoodmaxapipbMenuInsightsItemData[]
}

export interface FoodmaxapipbGetMenuInsightsTrendingResponse {
  result: FoodmaxapipbMenuInsightsTrending[]
}

export interface FoodmaxapipbGetMenuPhotosResponse {
  menus: Record<string, FoodmaxapipbPhotoList>
}

export interface FoodmaxapipbGetMenuScanResultResponse {
  parentTaskStatus: string
  categories: FoodmaxapipbItemCategory[]
}

export interface FoodmaxapipbGetMenuTaskStatusResponse {
  status: string
  result: Record<string, string>
  errors: Record<string, string>
}

export interface FoodmaxapipbGetMerchantGrabPayGrabIDResponse {
  grabPayGrabID: string
}

export interface FoodmaxapipbGetMerchantGroupIDsByGrabPayGrabIDResponse {
  merchantGroupIDs: string[]
}

export interface FoodmaxapipbGetMerchantGroupResponse {
  merchantGroup: FoodmaxapipbMerchantGroup
}

export interface FoodmaxapipbGetMerchantIDByGrabPayGrabIDResponse {
  merchantID: string
  merchantIDs: string[]
}

export interface FoodmaxapipbGetMerchantOpenStatusV3Response {
  isOpen: boolean
  /** @format int32 */
  closeReason: number
  isInSpecialOpeningHourRange: boolean
  meta: FoodmaxapipbOpenStatusMeta
  isMexInBusyMode: boolean
  needDailyCheckIn: boolean
  checkInMessage: FoodmaxapipbCheckInMessage
  upcomingFestive: FoodmaxapipbUpcomingFestive
  manualAcceptMode: FoodmaxapipbManualAcceptMode
  statusDisplayInfo: FoodmaxapipbStatusDisplayInfo
}

export interface FoodmaxapipbGetMerchantOrderCountResponse {
  /** @format int64 */
  count: number
}

export interface FoodmaxapipbGetMerchantOutletProfilesResponse {
  hasMore: boolean
  profiles: FoodmaxapipbProfile[]
}

export interface FoodmaxapipbGetMerchantReportSummaryResponse {
  currency: FoodmaxapipbCurrency
  /** @format int64 */
  totalEarningsInMinorUnit: number
  totalEarningDisplay: string
  /** @format int64 */
  revenueInMinorUnit: number
  revenueDisplay: string
  /** @format int32 */
  completedOrders: number
  /** @format int32 */
  cancelledOrders: number
  /** @format int32 */
  maxSupportedTimeRangeDays: number
}

export interface FoodmaxapipbGetMerchantReportV3Response {
  currency: FoodmaxapipbCurrency
  /** @format int64 */
  totalEarningsInMinorUnit: number
  /** @format int64 */
  orderNums: number
  statements: FoodmaxapipbOrderStatement[]
  totalEarningDisplay: string
}

export interface FoodmaxapipbGetMerchantReportWithPaginationV1Response {
  hasMore: boolean
  /** @format int64 */
  pageIndex: number
  /** @format date-time */
  pageEndTime: string
  statements: FoodmaxapipbOrderStatement[]
  /** @format int64 */
  pageSize: number
}

export interface FoodmaxapipbGetMerchantReportsV3Response {
  statements: FoodmaxapipbDailyStatement[]
}

export interface FoodmaxapipbGetMerchantResponse {
  merchant: FoodmaxapipbMerchant
  /** @format date-time */
  nextOpenTime: string
  /** @format int32 */
  updateOpeningHoursTimes: number
  /** @format int32 */
  maxOpeningPeriods: number
  setting: FoodmaxapipbMerchantSetting
  merchantUser: FoodmaxapipbMerchantUser
  dailyCheckIn: boolean
}

export interface FoodmaxapipbGetMerchantReviewThrottleResponse {
  /** @format int32 */
  reviewUnreportableReason: number
  /** @format int32 */
  reviewsReportedPercentage: number
  /** @format int32 */
  reviewsReportedIncorrectlyPercentage: number
  /** @format date-time */
  reviewsEvaluationStartDate: string
  /** @format date-time */
  reviewsEvaluationEndDate: string
  /** @format date-time */
  reviewsReportingFreezeEndDate: string
}

export interface FoodmaxapipbGetMerchantSettingsV1Response {
  bankInfo: FoodmaxapipbBank
  autoCallInfo: FoodmaxapipbAutoCallSetting
  /** @format int32 */
  isAutoAcceptEnabled: number
}

export interface FoodmaxapipbGetModifierGroupDetailsByModifierGroupIDsResponse {
  modifierGroups: FoodmaxapipbModifierGroup[]
}

export interface FoodmaxapipbGetNewReviewCountResponse {
  /** @format int64 */
  newReviewCount: number
}

export interface FoodmaxapipbGetNotificationCountResponse {
  /** @format date-time */
  timestamp: string
  /** @format int32 */
  campaignEvents: number
}

export interface FoodmaxapipbGetNotificationListV2Response {
  notifications: FoodmaxapipbNotificationEntity[]
  /** @format date-time */
  timestamp: string
}

export interface FoodmaxapipbGetOrderPickingUpETAResponse {
  pickingUpEta: FoodmaxapipbPickingUpETA[]
  /** @format int32 */
  ttl: number
}

export interface FoodmaxapipbGetOrderResponse {
  order: FoodmaxapipbOrder
}

export interface FoodmaxapipbGetOrderStatusV2Response {
  status: string
  deliveryTaskpoolStatus: string
  preparationTaskpoolStatus: string
  /** @format int64 */
  cancelCode: number
  /** @format date-time */
  deliveredAt: string
  /** @format date-time */
  expiredAt: string
  driver: FoodmaxapipbDriverInOrderV2
  displayID: string
  bookingCode: string
  /** @format date-time */
  completedAt: string
  isEditable: boolean
  /** @format int64 */
  uneditableReason: number
  cancelBy: string
  isDeliverByMex: boolean
  /** @format int32 */
  geAllocationStatus: number
  grabExpressDriver: FoodmaxapipbGrabExpressDriver
  chatroomInfo: FoodmaxapipbChatroomInfo
  orderBookings: FoodmaxapipbBookingInOrderV2[]
  flags: FoodmaxapipbOrderFlags
  replacementInfo: FoodmaxapipbReplacementInfo
  isEditableByPax: boolean
  orderReadyPhotoDetail: FoodmaxapipbOrderReadyPhotoDetail
  th5050OrderDetail: FoodmaxapipbTH5050OrderDetail
  /** @format date-time */
  readyAt: string
  eInvoiceCarrierDisplay: FoodmaxapipbEInvoiceCarrierDisplay
  eInvoiceCarrierSection: FoodmaxapipbEInvoiceCarrierSection
}

export interface FoodmaxapipbGetOrderUnchangeableReasonsResponse {
  /** @format int64 */
  cancelLimitType: number
  /** @format int64 */
  cancelLimitTimes: number
  /** @format int64 */
  noncancelableReason: number
  isCancelable: boolean
  /** @format int64 */
  cancelLimitTime: number
  /** @format int64 */
  uneditableReason: number
  isEditable: boolean
  cancelReasons: FoodmaxapipbCancelReason[]
  meoTotalValueLimitDisplay: string
  /** @format int64 */
  meoTotalIncreaseLimitSymbol: number
  meoTotalIncreaseLimitValue: string
  /** @format int64 */
  meoPerItemPriceLimit: number
  /** @format float */
  meoPerItemPricePercentageLimit: number
  isEditableByPax: boolean
}

export interface FoodmaxapipbGetOrderV3Response {
  order: FoodmaxapipbOrderV2
}

export interface FoodmaxapipbGetOrdersWithPaginationV2Response {
  /** @format int32 */
  unreadNumberInNew: number
  /** @format int32 */
  unreadAANumberInPrepare: number
  /** @format int32 */
  unreadViaCallNumberInPrepare: number
  /** @format int32 */
  numberInNew: number
  /** @format int32 */
  numberInPrepare: number
  /** @format date-time */
  nextRequestTimestamp: string
  merchantModel: string
  isOpen: boolean
  orders: FoodmaxapipbSimpleOrderV2[]
  haveMore: boolean
  pageType: string
  /** @format int32 */
  numberReady: number
  /** @format int32 */
  numberInDelivering: number
}

export interface FoodmaxapipbGetOrdersWithPaginationV3Response {
  orderStats: FoodmaxapipbOrderStats
  /** @format date-time */
  nextRequestTimestamp: string
  hasMore: boolean
  orders: FoodmaxapipbOrderInList[]
  /** @format int32 */
  pollInterval: number
  /** @format date-time */
  serverTime: string
}

export interface FoodmaxapipbGetPrintableOrdersTimestampV2Response {
  /** @format date-time */
  timestamp: string
}

export interface FoodmaxapipbGetPrintableOrdersV3Response {
  orders: FoodmaxapipbOrderV2[]
  failedOrders: FoodmaxapipbFailedOrder[]
}

export interface FoodmaxapipbGetRecentSearchKeysResponse {
  searchKey: string[]
}

export interface FoodmaxapipbGetReviewByIDResponse {
  review: FoodmaxapipbReview
}

export interface FoodmaxapipbGetReviewByOrderIDResponse {
  review: FoodmaxapipbReview
}

export interface FoodmaxapipbGetReviewTranslationResponse {
  should_display_see_original: boolean
  allow_report_translation: boolean
  content: string
  lang_code: string
  lang_name: string
  highlighted_content: string
}

export interface FoodmaxapipbGetScheduledOrdersResponse {
  orders: FoodmaxapipbSimpleOrderV2[]
  /** @format int64 */
  unreadCount: number
}

export interface FoodmaxapipbGetSelfServeActivationJourneyResponse {
  ID: string
  partner: FoodmaxapipbSelfServePartner
  status: string
  stage: string
  menu: FoodmaxapipbSelfServeMenu
  error: FoodmaxapipbSelfServeError
  grab: FoodmaxapipbSelfServeGrab
  /** @format date-time */
  activatedAt: string
  /** @format date-time */
  updatedAt: string
  /** @format date-time */
  createdAt: string
}

/** GetSelfServeCampaignConfigResponse is the response object for GetSelfServeCampaignConfig */
export interface FoodmaxapipbGetSelfServeCampaignConfigResponse {
  selfServeCampaignConfig: FoodmaxapipbSelfServeCampaignConfig
}

/** GetSelfServeCampaignEstimatedOrdersRequest is the request object for GetSelfServeCampaignEstimatedOrders */
export interface FoodmaxapipbGetSelfServeCampaignEstimatedOrdersRequest {
  /** @format double */
  costPerClick: number
  campaignType: FoodmaxapipbSelfServeCampaignType
  campaignTime: FoodmaxapipbCampaignTime
  /** @format double */
  dailyBudget: number
}

/** GetSelfServeCampaignEstimatedOrdersResponse is the repsonse object for GetSelfServeCampaignEstimatedOrders */
export interface FoodmaxapipbGetSelfServeCampaignEstimatedOrdersResponse {
  /** @format int64 */
  minEstimatedOrders: number
  /** @format int64 */
  maxEstimatedOrders: number
  /** @format int64 */
  clicks: number
}

/** GetSelfServeCampaign is the response object for GetSelfServeCampaign */
export interface FoodmaxapipbGetSelfServeCampaignResponse {
  selfServeCampaigns: FoodmaxapipbSelfServeCampaign
}

/** GetSelfServeMerchantInfoResponse is the repsonse object for GetSelfServeMerchantInfo */
export interface FoodmaxapipbGetSelfServeMerchantInfoResponse {
  image: FoodmaxapipbImage
  /** @format double */
  merchantRating: number
  primaryCuisines: string[]
  brandName: string
  itemImages: FoodmaxapipbImage[]
}

export interface FoodmaxapipbGetSellingTimeResponse {
  sellingTime: FoodmaxapipbSellingTime
}

export interface FoodmaxapipbGetServiceMetaResponse {
  ceEmail: string
  cePhone: string
  ceWorkingTime: FoodmaxapipbWorkingTime
  ceWebsite: string
}

export interface FoodmaxapipbGetStoreProfileResponse {
  storeProfile: FoodmaxapipbStoreProfile
}

export interface FoodmaxapipbGetSupportedAttributeClustersResponse {
  supportedAttributeClusters: CatalogpbSupportedAttributeClusters[]
  supportedAttributeClusterMap: CatalogpbAttributeClusterMap
}

export interface FoodmaxapipbGetTranslationRequest {
  textType: string
  entity: string
  text: string
  textSourceLang: string
  textTargetLang: string[]
}

export interface FoodmaxapipbGetTranslationResponse {
  textTranslation: Record<string, string>
  metadata: Record<string, FoodmaxapipbTranslationMetadata>
}

export interface FoodmaxapipbGetUnavailableItemsResponse {
  /** @format int32 */
  unavailableItemCount: number
  /** @format int32 */
  lowStockItemCount: number
}

export interface FoodmaxapipbGiftInfo {
  giftNote: string
  giftHeader: string
  giftTitle: string
  giftDesc: string
}

export interface FoodmaxapipbGrabExpressDriver {
  name: string
  mobileNumber: string
  trackingUrl: string
}

export interface FoodmaxapipbGrabMartFeatureEnabled {
  isGrabMartV2Enabled: boolean
  isGrabMartV2ForAppBrandEnabled: boolean
  isGrabMartV2ForItemAttributesEnabled: boolean
  isGrabMartV2ForEditingItemAttributesEnabled: boolean
  isPrintSKUCodeEnabled: boolean
  departmentEnabled: boolean
}

export interface FoodmaxapipbHierarchyEntity {
  id: string
  name: string
  /** @format int32 */
  availableStatus: number
  /** @format int32 */
  sortOrder: number
  sellingTimeID: string
  nameTranslation: FoodmaxapipbNilableTranslation
  /** @format int32 */
  totalItems: number
  /** @format int32 */
  totalOutOfStocksItems: number
  /** @format int32 */
  totalLowOfStocksItems: number
  entityType: FoodmaxapipbEntityType
  /** @format int32 */
  totalHiddenItems: number
  imageURL: string
}

export interface FoodmaxapipbImage {
  imageType: FoodmaxapipbImageType
  imageURL: string
}

export interface FoodmaxapipbImageAsset {
  url: string
  tags: string[]
  /** @format int64 */
  width: number
  /** @format int64 */
  height: number
}

/** @default "ITEM_IMAGE" */
export enum FoodmaxapipbImageType {
  ITEM_IMAGE = "ITEM_IMAGE",
  MERCHANT_IMAGE = "MERCHANT_IMAGE",
}

export interface FoodmaxapipbIncidentAffectItem {
  id: string
  name: string
  /** @format int64 */
  quantity: number
  /** @format double */
  priceInMajorUnit: number
  modifiers: FoodmaxapipbIncidentAffectItem[]
}

/** IntegrationStatus represents the merchant's POS integration status */
export interface FoodmaxapipbIntegrationStatus {
  apiIntegratedAndActive: boolean
  posDisplayName: string
  posRedirectLink: string
  partnerId: string
  qsrCode: string
}

export interface FoodmaxapipbItemAttributeValue {
  itemID: string
  attributeID: string
  value: string
  cluster: string
  /** @format int64 */
  version: number
  itemAttributeValueID: string
  status: string
  attributeClusterID: string
  metadata: CatalogpbItemAttributeValueMetadata
}

export interface FoodmaxapipbItemCampaignInfo {
  ongoingCampaignID: string
}

export interface FoodmaxapipbItemCategory {
  categoryID: string
  categoryName: string
  /** @format int32 */
  availableStatus: number
  /** @format int32 */
  sortOrder: number
  items: FoodmaxapipbItemV2[]
  sellingTimeID: string
  nameTranslation: FoodmaxapipbNilableTranslation
  menuScanError: Record<string, string>
  menuScanTaskMeta: FoodmaxapipbMenuScanTaskMeta
}

export interface FoodmaxapipbItemClass {
  ItemClassID: string
  Name: string
  Status: string
  ParentID: string
  ParentClassName: string
}

export interface FoodmaxapipbItemDepartment {
  itemClassID: string
  itemClassName: string
  /** @format int32 */
  sortOrder: number
  /** @format int32 */
  totalItems: number
  /** @format int32 */
  totalUnavailableItems: number
  items: FoodmaxapipbItemV2[]
  subDepartments: FoodmaxapipbItemDepartment[]
  sellingTimeID: string
  attributeCluster: string[]
  /** @format int32 */
  totalLowStockItems: number
  /** @format int32 */
  totalHiddenItems: number
}

export interface FoodmaxapipbItemDiscountInfo {
  discountName: string
  discountFunding: string
  itemDiscountPriceDisplay: string
  isNewPromotion: boolean
  discountType: string
}

export interface FoodmaxapipbItemFare {
  currencyCode: string
  currencySymbol: string
  currencyExponent: string
  /** @format int64 */
  currencyExponentUnit: number
  /** @format int64 */
  priceInCent: number
  priceDisplay: string
  /** @format int64 */
  priceInMin: number
}

export interface FoodmaxapipbItemFareV2 {
  currencySymbol: string
  priceDisplay: string
  originalItemPriceDisplay: string
  beforeAdjustedPriceDisplay: string
  /** @format float */
  priceFloat: number
  /** @format int64 */
  priceInMin: number
}

export interface FoodmaxapipbItemInOrder {
  ID: string
  name: string
  description: string
  /** @format int32 */
  quantity: number
  icons: string[]
  photos: string[]
  fare: FoodmaxapipbItemFare
}

export interface FoodmaxapipbItemInOrderList {
  itemID: string
  name: string
  /** @format int64 */
  quantity: number
  weight: FoodmaxapipbSizeAttribute
}

export interface FoodmaxapipbItemInOrderV2 {
  name: string
  /** @format int32 */
  quantity: number
  fare: FoodmaxapipbItemFareV2
  comment: string
  modifierGroups: FoodmaxapipbModifierGroupInOrderV2[]
  discountInfo: FoodmaxapipbItemDiscountInfo[]
  itemID: string
  /**
   * 0 no changes
   * 1 added
   * 2 updated
   * 3 deleted
   * 4 itemQuantityUpdated
   * @format int32
   */
  editedStatus: number
  weight: FoodmaxapipbSizeAttribute
  itemCode: string
  specialItemType: string
  soldByWeight: boolean
  outOfStockInstruction: FoodmaxapipbOutOfStockInstruction
  parentID: string
  parentName: string
  skuID: string
  isAddedAsReplacement: boolean
  image: string
  itemKey: string
  barcode: string
  originalItem: FoodmaxapipbReplacementItemInfo
  outOfStockInstructionV2: FoodmaxapipbOutOfStockInstructionV2
  originalFare: FoodmaxapipbItemFareV2
  isUneditable: boolean
  itemTags: string[]
  memberPriceInfo: CommonpbMemberPriceInfo
}

export interface FoodmaxapipbItemMenuDisplayResponse {
  sections: FoodmaxapipbItemSection[]
  modifierGroups: FoodmaxapipbModifierGroup[]
  isMenuEditorEnabled: boolean
  isPartnerEditorEnabled: boolean
  attributesData: CatalogpbAttributesData
}

export interface FoodmaxapipbItemMenuDisplayV2Response {
  categories: FoodmaxapipbItemCategory[]
  modifierGroups: FoodmaxapipbModifierGroup[]
  sellingTimes: FoodmaxapipbSellingTime[]
  isMenuEditorEnabled: boolean
  attributesData: CatalogpbAttributesData
  stockPhotoUsageStatus: string
}

/** @default "unknown" */
export enum FoodmaxapipbItemMetricType {
  Unknown = "unknown",
  Sold = "sold",
  Gross = "gross",
  Popular = "popular",
}

export interface FoodmaxapipbItemSection {
  sectionID: string
  sectionName: string
  /** @format int32 */
  sortOrder: number
  /** @format int32 */
  availableStatus: number
  categories: FoodmaxapipbItemCategory[]
  openingHours: FoodmaxapipbOpeningHoursPerDay[]
}

export interface FoodmaxapipbItemSortTo {
  itemID: string
  /** @format int32 */
  sortOrder: number
}

export interface FoodmaxapipbItemStock {
  enableIms: boolean
  /** @format int32 */
  currentStock: number
  enableRestock: boolean
  restockSetting: FoodmaxapipbRestockSetting
}

export interface FoodmaxapipbItemStockPrediction {
  lowStock: boolean
  predictedLowStockAt: string
}

export interface FoodmaxapipbItemUpsertExtraParams {
  specialMode: ItemUpsertExtraParamsSpecialMode
}

export interface FoodmaxapipbItemV2 {
  itemID: string
  itemName: string
  /** @format int32 */
  availableStatus: number
  priceDisplay: string
  /** @format int32 */
  sortOrder: number
  description: string
  imageURL: string
  /** @format int64 */
  priceInMin: number
  weight: FoodmaxapipbSizeAttribute
  itemCode: string
  itemClassID: string
  specialItemType: string
  itemClassName: string
  skuID: string
  brandName: string
  itemStock: FoodmaxapipbItemStock
  linkedModifierGroupIDs: string[]
  soldByWeight: boolean
  webPURL: string
  sellingTimeID: string
  priceRange: string
  advancedPricing: Record<string, CatalogpbPricing>
  purchasability: Record<string, boolean>
  attributes: FoodmaxapipbItemAttributeValue[]
  imageURLs: string[]
  webPURLs: string[]
  serviceTypePriceRange: Record<string, string>
  /** @format date-time */
  availableAt: string
  stockPrediction: FoodmaxapipbItemStockPrediction
  parentItemClassID: string
  parentItemClassName: string
  nameTranslation: FoodmaxapipbNilableTranslation
  descriptionTranslation: FoodmaxapipbNilableTranslation
  supportedAttributeClusterIDs: string[]
  prediction: FoodmaxapipbPredictions
  menuScanError: Record<string, string>
  aiGeneratedFields: string[]
  suggestFields: Record<string, string>
  /** @format int64 */
  soldQuantity: number
  itemCampaignInfo: FoodmaxapipbItemCampaignInfo
  menuScanTaskMeta: FoodmaxapipbMenuScanTaskMeta
  oosNonReplacementReason: string
  eligibleSellingStatus: string
  m41MetaData: FoodmaxapipbM41MetaData
  categoryID: string
  categoryName: string
  failedPhotos: FoodmaxapipbFailedPhoto[]
  bcrsInfo: FoodmaxapipbBCRSInfo
  masterItemID: string
  categoryTreeNodeID: string
}

export interface FoodmaxapipbItemValidationConfig {
  /** @format int64 */
  itemDescriptionMinLength: number
  /** @format int64 */
  itemDescriptionMaxLength: number
}

export interface FoodmaxapipbItemValidationRequest {
  item: FoodmaxapipbItemV2
  categoryID: string
  extraParams: FoodmaxapipbItemUpsertExtraParams
}

export interface FoodmaxapipbItemWeightLimitSetting {
  /** @format int64 */
  itemWarningWeightLimit: number
  /** @format int64 */
  itemBlockWeightLimit: number
}

export interface FoodmaxapipbItemsInOrder {
  /** @format int64 */
  count: number
  items: FoodmaxapipbItemInOrder[]
}

export interface FoodmaxapipbItemsInOrderList {
  /** @format int64 */
  count: number
  items: FoodmaxapipbItemInOrderList[]
}

export interface FoodmaxapipbItemsInOrderV2 {
  /** @format int64 */
  count: number
  items: FoodmaxapipbItemInOrderV2[]
  merchantItems: FoodmaxapipbMerchantItem[]
  itemsSubtotalPriceDisplay: string
  itemsSubtotalTaxDisplay: string
}

export interface FoodmaxapipbKeyword {
  name: string
  searchPerDayDisplay: string
}

export interface FoodmaxapipbKeywordReport {
  keyword: string
  /** @format double */
  merchantSpent: number
  /** @format double */
  incrementalSales: number
  /** @format int64 */
  incrementalOrders: number
  /** @format double */
  roi: number
  merchantSpentDisplay: string
  incrementalSalesDisplay: string
  /** @format int64 */
  clicks: number
}

export interface FoodmaxapipbLeadsGenData {
  isDeliverByMex: boolean
  isOrderValueLow: boolean
  deliveryFee: string
  /** @format int32 */
  timeLeftToEnableCompleteButton: number
  /** @format int32 */
  geAllocationStatus: number
  grabExpressDriver: FoodmaxapipbGrabExpressDriver
  /** @format int32 */
  paxDistanceToMex: number
}

export interface FoodmaxapipbLearnMoreInfo {
  text: string
  link: string
}

export interface FoodmaxapipbLinkStoresToMenuGroupRequest {
  menuGroupID: string
  storeIDs: string[]
}

export interface FoodmaxapipbLinkStoresToMenuGroupResponse {
  menuGroupID: string
}

export interface FoodmaxapipbListAttributesResponse {
  hasMore: boolean
  attributes: FoodmaxapipbAttribute[]
}

export interface FoodmaxapipbListCampaignResponse {
  campaigns: FoodmaxapipbMerchantCampaigns
  priceConfig: Record<string, FoodmaxapipbDiscountHygiene>
  /** @format int32 */
  maxCampaignLimit: number
  campaignEvents: FoodmaxapipbMerchantCampaignEvents
}

export interface FoodmaxapipbListCountryServicesResponse {
  countryGroups: FoodmaxapipbServiceCountryGroup[]
}

export interface FoodmaxapipbListIncidentsResponse {
  incidents: FoodmaxapipbmavIncident[]
  hasMore: boolean
}

export interface FoodmaxapipbListItemClassesResponse {
  itemClasses: FoodmaxapipbItemClass[]
  more: boolean
}

export interface FoodmaxapipbListMenuGroupAttributesResponse {
  hasMore: boolean
  attributes: FoodmaxapipbAttribute[]
}

export interface FoodmaxapipbListMenuGroupResponse {
  menuGroups: FoodmaxapipbMenuGroup[]
  hasMore: boolean
}

export interface FoodmaxapipbListMenuGroupSellingTimesResponse {
  hasMore: boolean
  sellingTimes: FoodmaxapipbMenuGroupSellingTime[]
}

export interface FoodmaxapipbListMenuGroupStoresResponse {
  storeIDs: string[]
  hasMore: boolean
}

/** ListMerchantPromotions is the response object for ListMerchantPromotions */
export interface FoodmaxapipbListMerchantPromotionsResponse {
  promotions: FoodmaxapipbPromotion[]
  /** @format uint64 */
  limit: number
  /** @format uint64 */
  offset: number
  /** @format uint64 */
  count: number
}

export interface FoodmaxapipbListReviewsResponse {
  reviews: FoodmaxapipbReview[]
  nextToken: string
}

/** ListSelfServeCampaignsResponse is the response object for ListSelfServeCampaigns */
export interface FoodmaxapipbListSelfServeCampaignsResponse {
  selfServeCampaigns: FoodmaxapipbSelfServeCampaign[]
  /** @format uint64 */
  limit: number
  /** @format uint64 */
  offset: number
  /** @format uint64 */
  count: number
}

/** ListSelfServeRecommendedKeywordsResponse is the request object for ListSelfServeRecommendedKeywords */
export interface FoodmaxapipbListSelfServeRecommendedKeywordsResponse {
  keywords: FoodmaxapipbKeyword[]
}

export interface FoodmaxapipbListSellingTimesResponse {
  hasMore: boolean
  sellingTimes: FoodmaxapipbSellingTime[]
}

export interface FoodmaxapipbListStoreProfilesResponse {
  storeProfiles: FoodmaxapipbStoreProfile[]
}

export interface FoodmaxapipbLocationInDriverInOrderV2 {
  /** @format float */
  latitude: number
  /** @format float */
  longitude: number
}

export interface FoodmaxapipbLoginResponseV1 {
  jwt: string
  devMessage: string
  arg: string
  cePhone: string
}

export interface FoodmaxapipbM41MenuConfirmRequest {
  items: M41MenuConfirmRequestitemWithM41Operation[]
}

export interface FoodmaxapipbM41MenuConfirmResponse {
  succeedItems: M41MenuConfirmResponseSucceedItems
  failedItems: M41MenuConfirmResponseFailedItems
}

export interface FoodmaxapipbM41MenuPreviewResponse {
  entranceContent: string
  selectContent: string
  reviewContent: string
  onboardingContent: string
  eligibilityItems: M41MenuPreviewResponseItemWithM41Info[]
  m41Items: M41MenuPreviewResponseItemWithM41Info[]
}

export interface FoodmaxapipbM41MetaData {
  m41Source: string
  m41RelationShipItemID: string
}

export interface FoodmaxapipbM41SearchItem {
  item: FoodmaxapipbItemV2
  isM41: boolean
  discountPrice: string
  m41Status: string
  m41StatusContent: string
  m41StatusIconUrl: string
  displayDiscountPrice: string
  m41Source: string
  m41RelationShipItemID: string
}

export interface FoodmaxapipbM41SearchResult {
  title: string
  m41Items: FoodmaxapipbM41SearchItem[]
}

export interface FoodmaxapipbMIWIRisk {
  highRisk: boolean
}

export interface FoodmaxapipbMSSCampaignFeatureEnabled {
  isAudienceEnabled: boolean
  isDayOfWeekEnabled: boolean
  isTimeOfDayEnabled: boolean
  isKeywordsEnabled: boolean
  isCampaignTypeBannerEnabled: boolean
  isCampaignTypeSearchEnabled: boolean
  isPromotionPriority: boolean
}

export interface FoodmaxapipbManualAcceptMode {
  /** @format int32 */
  maChangeType: number
  content: string
  skipTempPauseStatus: boolean
}

export interface FoodmaxapipbMarkOrdersAsPrintedV2Request {
  orderIDs: string[]
}

export interface FoodmaxapipbMarkOrdersReadV2Request {
  orderIDs: string[]
}

export interface FoodmaxapipbMarkOrdersRequest {
  orderIDs: string[]
  /** @format int64 */
  markStatus: number
  preparationTaskIDs: string[]
}

export interface FoodmaxapipbMartItemMenuDisplayResponse {
  sections: FoodmaxapipbMartItemSection[]
  modifierGroups: FoodmaxapipbModifierGroup[]
  isMenuEditorEnabled: boolean
  attributesData: CatalogpbAttributesData
}

export interface FoodmaxapipbMartItemMenuDisplayV2Response {
  departments: FoodmaxapipbItemDepartment[]
  modifierGroups: FoodmaxapipbModifierGroup[]
  sellingTimes: FoodmaxapipbSellingTime[]
  isMenuEditorEnabled: boolean
  attributesData: CatalogpbAttributesData
}

export interface FoodmaxapipbMartItemSection {
  sectionID: string
  sectionName: string
  /** @format int32 */
  sortOrder: number
  /** @format int32 */
  availableStatus: number
  departments: FoodmaxapipbItemDepartment[]
  openingHours: FoodmaxapipbOpeningHoursPerDay[]
}

export interface FoodmaxapipbMcorV2FeatureEnabled {
  McorV2Enabled: boolean
  ExperimentGroup: string
  NewMorUIEnabled: boolean
}

export interface FoodmaxapipbMenuActionAcknowledgeRequest {
  previewCards: FoodmaxapipbPreviewCard[]
}

export interface FoodmaxapipbMenuActionAcknowledgeResponse {
  sessionID: string
  messages: string[]
  tips: string[]
}

export interface FoodmaxapipbMenuEditorFeatureEnabled {
  searchDepartment: boolean
}

export interface FoodmaxapipbMenuEntity {
  type: string
  id: string
  data: KitRawJSON
}

export interface FoodmaxapipbMenuEntityValidationRequest {
  menu_entities: FoodmaxapipbMenuEntity[]
}

export interface FoodmaxapipbMenuEntityValidationResponse {
  errors: FoodmaxapipbValidationError[]
}

export interface FoodmaxapipbMenuGroup {
  menuGroupID: string
  name: string
  /** @format int32 */
  ownerType: number
  ownerID: string
  /** @format int64 */
  countryID: number
  status: string
  /** @format int32 */
  businessType: number
  /** @format int32 */
  menuType: number
  /** @format int32 */
  latestPropagateStatus: number
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  timeZone: string
  /** @format int32 */
  itemsWithoutPhotosCount: number
  languageSettings: FoodmaxapipbMenuGroupLangSettings
}

export interface FoodmaxapipbMenuGroupItemMenuDisplayV1Response {
  sections: FoodmaxapipbItemSection[]
  modifierGroups: FoodmaxapipbModifierGroup[]
  isMenuEditorEnabled: boolean
  attributesData: CatalogpbAttributesData
  isAlcoholSaleAllowed: boolean
  isTobaccoSaleAllowed: boolean
}

export interface FoodmaxapipbMenuGroupItemMenuDisplayV2Response {
  categories: FoodmaxapipbItemCategory[]
  modifierGroups: FoodmaxapipbModifierGroup[]
  sellingTimes: FoodmaxapipbMenuGroupSellingTime[]
  isMenuEditorEnabled: boolean
  attributesData: CatalogpbAttributesData
  isAlcoholSaleAllowed: boolean
  isTobaccoSaleAllowed: boolean
}

export interface FoodmaxapipbMenuGroupItemValidationRequest {
  item: FoodmaxapipbItemV2
  categoryID: string
  menuGroupID: string
}

export interface FoodmaxapipbMenuGroupLangSettings {
  menuDefaultLanguage: string
  menuSupportedLanguages: string[]
  isAutoTranslationEnabled: boolean
  languageFullNames: Record<string, string>
  translationFieldMandatoryLanguages: string[]
  translationModelSupportedLanguages: string[]
}

export interface FoodmaxapipbMenuGroupMartItemMenuDisplayV1Response {
  sections: FoodmaxapipbMartItemSection[]
  modifierGroups: FoodmaxapipbModifierGroup[]
  isMenuEditorEnabled: boolean
  attributesData: CatalogpbAttributesData
  isAlcoholSaleAllowed: boolean
  isTobaccoSaleAllowed: boolean
}

export interface FoodmaxapipbMenuGroupMartItemMenuDisplayV2Response {
  departments: FoodmaxapipbItemDepartment[]
  modifierGroups: FoodmaxapipbModifierGroup[]
  sellingTimes: FoodmaxapipbMenuGroupSellingTime[]
  isMenuEditorEnabled: boolean
  attributesData: CatalogpbAttributesData
  isAlcoholSaleAllowed: boolean
  isTobaccoSaleAllowed: boolean
}

export interface FoodmaxapipbMenuGroupSection {
  sectionID: string
  menuGroupID: string
  name: string
  /** @format int32 */
  cmplxSortOrder: number
  status: string
  serviceHours: CommonpbHoursByWeekDay
  /** @format date-time */
  updatedAt: string
  /** @format date-time */
  createdAt: string
  externalID: string
}

export interface FoodmaxapipbMenuGroupSellingTime {
  sellingTimeID: string
  menuGroupID: string
  name: string
  status: string
  serviceHours: CommonpbHoursByWeekDay
  /** @format date-time */
  updatedAt: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  startTime: string
  /** @format date-time */
  endTime: string
}

export interface FoodmaxapipbMenuGroupSetting {
  disableEditMenu: boolean
  itemEditableFields: string[]
}

export interface FoodmaxapipbMenuGroupUpsertItemV2Request {
  item: FoodmaxapipbItemV2
  categoryID: string
  menuGroupID: string
  itemAttributeValues: FoodmaxapipbItemAttributeValue[]
}

export interface FoodmaxapipbMenuGroupUpsertItemV2Response {
  itemID: string
}

export interface FoodmaxapipbMenuInsightsCombo {
  combo: FoodmaxapipbMenuInsightsComboItem[]
  comboID: string
  /** @format double */
  score: number
  /** @format int64 */
  segmentID: number
}

export interface FoodmaxapipbMenuInsightsComboItem {
  itemID: string
  itemName: string
  /** @format int64 */
  quantity: number
}

export interface FoodmaxapipbMenuInsightsItemData {
  /** @format int64 */
  seqID: number
  itemID: string
  itemName: string
  /** @format int64 */
  totalQuantity: number
  /** @format double */
  totalSales: number
  /** @format double */
  rating: number
  displayValue: string
}

export interface FoodmaxapipbMenuInsightsItemTrending {
  date: string
  /** @format int64 */
  totalQuantity: number
  /** @format double */
  totalSales: number
  /** @format double */
  rating: number
  displayValue: string
}

export interface FoodmaxapipbMenuInsightsTrending {
  cuisineName: string
  itemName: string
  totalPopularity: string
  displayValue: string
}

export interface FoodmaxapipbMenuItemSuggestion {
  item: FoodmaxapipbItemV2
  categoryID: string
  categoryName: string
  type: string
  content: string
  newItemSuggestions: FoodmaxapipbNewItemSuggestion[]
  feedbackSuggestion: FoodmaxapipbReview
}

export interface FoodmaxapipbMenuScanTaskMeta {
  menuScanTaskID: string
  menuScanTaskIDItemID: string
}

export interface FoodmaxapipbMenuTranslationSetting {
  menuDefaultLanguage: string
  menuSupportedLanguages: string[]
  isAutoTranslationEnabled: boolean
  isTranslationFieldMandatory: boolean
  languageFullNames: Record<string, string>
  translationFieldMandatoryLanguages: string[]
  translationModelSupportedLanguages: string[]
}

export interface FoodmaxapipbMenuV3EditorStatusResponse {
  isMenuEditEnabled: boolean
  isAlcoholSaleAllowed: boolean
  isTobaccoSaleAllowed: boolean
  stockPhotoUsageStatus: string
  /** @format int32 */
  maxBatchItems: number
}

export interface FoodmaxapipbMenuV3HierarchiesResponse {
  hierarchies: FoodmaxapipbHierarchyEntity[]
  /** @format int32 */
  total: number
  /** @format int32 */
  pageIndex: number
  hasMore: boolean
  /** @format int32 */
  totalItems: number
  /** @format int32 */
  totalOutOfStocksItems: number
  /** @format int32 */
  totalLowOfStocksItems: number
  /** @format int32 */
  totalHiddenItems: number
}

export interface FoodmaxapipbMenuV3ItemFilter {
  sellingTimeID: string
  isOutOfStock: boolean
  isLowOfStock: boolean
  isHidden: boolean
}

export interface FoodmaxapipbMenuV3ItemsResponse {
  items: FoodmaxapipbItemV2[]
  /** @format int32 */
  total: number
  /** @format int32 */
  nextPageIndex: number
  hasMore: boolean
}

export interface FoodmaxapipbMenuV3ModifierGroupsResponse {
  modifierGroups: FoodmaxapipbModifierGroup[]
  /** @format int32 */
  total: number
  /** @format int32 */
  nextPageIndex: number
  hasMore: boolean
}

export interface FoodmaxapipbMenuValidationConfig {
  itemValidationConfig: FoodmaxapipbItemValidationConfig
  bcrsConfig: FoodmaxapipbBCRSConfig
}

export interface FoodmaxapipbMerchant {
  ID: string
  name: string
  description: string
  contractNumber: string
  mobileNumber: string
  tags: string[]
  /** @format double */
  latitude: number
  /** @format double */
  longitude: number
  /** @format float */
  rating: number
  openingHours: FoodmaxapipbOpeningHoursPerDay[]
  /** @format int64 */
  countryID: number
  /** @format int64 */
  cityID: number
  timezone: string
  district: string
  address: string
  tax: string
  /** @format int32 */
  businessType: number
  /** @format int64 */
  deliveryChargeInCents: number
  /** @format int64 */
  minConsumeFeeInCents: number
  halal: boolean
  /** @format date-time */
  contractDate: string
  /** @format date-time */
  expiredDate: string
  status: string
  isBookable: boolean
  isSupportOnline: boolean
  isAcceptSpecialOrderRequest: boolean
  editorials: string[]
  /** @format int32 */
  deliveryTime: number
  photo: string
  backgroundImg: string
  /** @format float */
  commission: number
  grabPayID: string
  /** @format int32 */
  paymentType: number
  /** @format int64 */
  poiID: number
  webSite: string
  isOpen: boolean
  /** @format int64 */
  serviceTypeID: number
  email: string
  /** @format date-time */
  updatedAt: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  closePeriodStart: string
  /** @format date-time */
  closePeriodEnd: string
  icon: string
  /** @format int64 */
  timezoneOffsetInSec: number
  model: string
  cePhone: string
  countryCode: string
  autoAcceptGroup: string
  isAnalyticsDashboardEnabled: boolean
  /** @format int64 */
  mlmPartner: number
  currency: FoodmaxapipbCurrency
  isMenuEditingEnabled: boolean
  isPromoModuleEnabled: boolean
  helpCenterUrl: Record<string, string>
  campaignHowItWorksUrl: Record<string, string>
  isLeadsGenHackSolutionEnabled: boolean
  isPasscodeCreated: boolean
  isPasscodeSkipped: boolean
  isPasscodeEnabled: boolean
  isPosIntegrationEnabled: boolean
  isInboxEnabled: boolean
  specialMerchantType: string
  supportTakeaway: boolean
  isMFCV2PartOneEnabled: boolean
  isMFCV2PartTwoEnabled: boolean
  isOrderLevelDiscountEnabled: boolean
  isScheduledOrderEnabled: boolean
  isTroyWhitelisted: boolean
  isEnableTroy: boolean
  grabPayGrabID: string
  merchantFlag: FoodmaxapipbMerchantFlag
  isTroyUserManagementEnabled: boolean
  specialOpeningHours: CommonpbHoursByDate[]
  tempPause: CommonpbTempPause
  optInCampaignHowItWorksUrl: Record<string, string>
  cancelOrderHelpCenterUrl: Record<string, string>
  isLeadsGenMerchant: boolean
  isEnableLeadsGenFulfill: boolean
  role: string
  /** @format int64 */
  featureFlag: number
  busyModeConfig: FoodmaxapipbMerchantBusyModeConfig
  smallPicture: string
  reviewTooltipUrl: string
  orderHelpCenterUrl: Record<string, string>
  blockOnDemandOrders: boolean
  storefrontEnabled: boolean
  supportDelivery: boolean
  supportDineIn: boolean
  dineInOpeningHours: FoodmaxapipbOpeningHoursPerDay[]
  isDineInOpeningHoursSet: boolean
  supportScheduledOrders: boolean
  isDineInOpen: boolean
  photoExhibition: FoodmaxapipbStorePhoto[]
  menuTranslationSetting: FoodmaxapipbMenuTranslationSetting
  featureFlags: Record<string, boolean>
  locationPhoneNumbers: string[]
  nameTranslation: FoodmaxapipbNilableTranslation
  brandNameTranslation: FoodmaxapipbNilableTranslation
  isChainMerchant: boolean
  featureFlagMapping: Record<string, boolean>
  publicEmail: string
  storeContactNumber: string
  storeContactEmail: string
  dineoutListingPhotoUrl: string
  /**
   * fpPostSync warns a migrated FoodPanda merchant about an UPCOMING full re-sync that will overwrite
   * their Grab-side changes. It is omitted entirely (absent, not null) when the notice does not apply.
   */
  fpPostSync: FoodmaxapipbFpPostSync
}

export interface FoodmaxapipbMerchantAttributes {
  /** @format int32 */
  poolID: number
  originalPoolName: string
  poolTitle: string
  pageContent: FoodmaxapipbCuisinePageLocalizeContent
  /** @format int32 */
  selectionLimit: number
  preferredAttributes: FoodmaxapipbAttributeValue[]
  attributes: FoodmaxapipbAttributeValue[]
  poolDescription: string
}

export interface FoodmaxapipbMerchantBusyModeConfig {
  /** @format int32 */
  busyModeFptLowerBound: number
  /** @format int32 */
  busyModeFptUpperBound: number
  /** @format int32 */
  busyModeApproach: number
}

export interface FoodmaxapipbMerchantCampaignEvents {
  recommended: FoodmaxapipbCampaignMerchantEvent[]
  pending: FoodmaxapipbCampaignMerchantEvent[]
}

export interface FoodmaxapipbMerchantCampaigns {
  ongoing: FoodmaxapipbCampaign[]
  upcoming: FoodmaxapipbCampaign[]
  history: FoodmaxapipbCampaign[]
  currency: FoodmaxapipbCurrency
  /** @format int32 */
  ongoingCount: number
  /** @format int32 */
  upcomingCount: number
}

export interface FoodmaxapipbMerchantFlag {
  isSupportNewReceipt: boolean
  isMexOptInCampaignEnabled: boolean
  isBannerVisible: boolean
  isTemperatureCardEnabled: boolean
  isMSSEnabled: boolean
  mssCampaignFeatureEnabled: FoodmaxapipbMSSCampaignFeatureEnabled
  isMexEditOrderEnabled: boolean
  isTroyWholesaleEnabled: boolean
  grabMartFeatureEnabled: FoodmaxapipbGrabMartFeatureEnabled
  posFeatureEnabled: FoodmaxapipbPosFeatureEnabled
  isMexCancelOrderEnabled: boolean
  isMenuInsightsEnabled: boolean
  isConcurrencyHandlingEnabled: boolean
  specialItemSettings: FoodmaxapipbSpecialItemSetting[]
  skipProofMenuEnabled: boolean
  menuEditorFeatureEnabled: FoodmaxapipbMenuEditorFeatureEnabled
  isEdithEnabled: boolean
  isOptInCampaignEnabledV2: boolean
  isMerchantChargesEnabled: boolean
  storeFrontSettings: FoodmaxapipbStoreFrontSettings
  isOrderListV3Enabled: boolean
  menuGroupSetting: FoodmaxapipbMenuGroupSetting
  multiPicsSetting: FoodmaxapipbMultiPicsSetting
  mssMarketingEntranceNewLogicEnabled: boolean
  isMssMigrateToImageAdsEnabled: boolean
  mcorV2FeatureEnabled: FoodmaxapipbMcorV2FeatureEnabled
  itemWeightLimitSetting: FoodmaxapipbItemWeightLimitSetting
  hasEnabledSendSTOCollectionNotification: boolean
  isAlcoholSaleAllowed: boolean
  isDepartmentTaggingEnhancement: boolean
  isInventoryManagementEnabled: boolean
  isTobaccoSaleAllowed: boolean
  isGlobalMREEnabled: boolean
  isAfterEarlyLiveV2CutoffTime: boolean
  isEarlyLifeV2Rollout: boolean
  isGoLive: boolean
}

export interface FoodmaxapipbMerchantGroup {
  ID: string
  name: string
  status: string
  invoiceEmails: string[]
  contactPhone: string
}

export interface FoodmaxapipbMerchantInOrder {
  ID: string
}

export interface FoodmaxapipbMerchantItem {
  merchantName: string
  items: FoodmaxapipbItemInOrderV2[]
}

export interface FoodmaxapipbMerchantQuota {
  condition: string
  /** @format int64 */
  totalCount: number
}

export interface FoodmaxapipbMerchantReimbursementComponentDetails {
  basketAmountDisplay: string
  deductionDisplay: string
  mexCommissionDisplay: string
  mfcDisplay: string
  mfpDisplay: string
  netTotalDisplay: string
  compensationDisplay: string
  withholdingTaxDisplay: string
  otherFeesAndChargesDisplay: string
  mfdDisplay: string
  stepUpCommissionDisplay: string
  vatDisplay: string
  pitDisplay: string
  vatPercentageDisplay: string
  pitPercentageDisplay: string
  compensationBeforeTaxDisplay: string
}

export interface FoodmaxapipbMerchantReimbursementInfo {
  isEligibleToReimburse: boolean
  isAutoReimburse: boolean
  isReimbursed: boolean
  /** @format int32 */
  expireDuration: number
  isPhotoProofNeeded: boolean
  /** @format int64 */
  reimburseStatus: number
  currency: string
  txID: string
  /** @format int32 */
  mreDisplayStrategy: number
  /** @format int32 */
  compensationType: number
  /** @format float */
  reimbursementRate: number
  componentDetails: FoodmaxapipbMerchantReimbursementComponentDetails
  /** @format float */
  reimbursementUpperRate: number
}

export interface FoodmaxapipbMerchantSetting {
  /** @format int32 */
  acceptCountDownInMin: number
  /** @format int32 */
  updateOpeningHoursTimes: number
  /** @format int32 */
  maxOpeningPeriods: number
  /** @format float */
  vat: number
  /** @format int32 */
  inboxMessageCount: number
  campaign: FoodmaxapipbCampaignSetting
  isPayOnCollect: boolean
}

export interface FoodmaxapipbMerchantUser {
  appUserEmail: string
}

export interface FoodmaxapipbMexChatActionRequest {
  roomID: string
  /** @format int64 */
  action: number
  orderID: string
  idempotentJoin: boolean
}

/** OPT stands for Order Preparation Time, renaming from FPT (Food Preparation Time) */
export interface FoodmaxapipbMexOPT {
  /** @format int64 */
  submittedOPTFromMex: number
  /** @format int32 */
  sourceOPT: number
  isPreparationTaskDelayed: boolean
  isReadyButtonAbused: boolean
  /** @format date-time */
  actualOPT: string
  /** @format date-time */
  estimatedOPTDoneAt: string
  /** @format int64 */
  remainEditableOPTInSec: number
  configuration: FoodmaxapipbMexOPTConfiguration
  /** @format int64 */
  preparationTaskDelayedByMin: number
}

export interface FoodmaxapipbMexOPTConfiguration {
  timeAdjustment: FoodmaxapipbTimeAdjustmentOPT
  /** @format int32 */
  step: number
  /** @format int32 */
  timerDuration: number
  /** @format int64 */
  editOPTWindowInSec: number
  /** @format int64 */
  editableOPTWindowInSec: number
}

export interface FoodmaxapipbMexSupplierCourierInfo {
  courierName: string
  trackingNumber: string
}

export interface FoodmaxapipbMinMaxRatingDetails {
  /** @format float */
  minStoreRating: number
  minStoreName: string[]
  /** @format float */
  maxStoreRating: number
  maxStoreName: string[]
}

export interface FoodmaxapipbModifier {
  modifierID: string
  modifierName: string
  priceDisplay: string
  isNeedExtraCost: boolean
  /** @format int32 */
  availableStatus: number
  /** @format int32 */
  sortOrder: number
  /** @format int32 */
  quantity: number
  /** @format int64 */
  priceInMin: number
  priceRange: string
  advancedPricing: Record<string, CatalogpbPricing>
  nameTranslation: FoodmaxapipbNilableTranslation
  /** @format int32 */
  maxModifierSelectionQuantity: number
  bcrsInfo: FoodmaxapipbBCRSInfo
}

export interface FoodmaxapipbModifierGroup {
  modifierGroupID: string
  modifierGroupName: string
  /** @format int32 */
  selectionRangeMin: number
  /** @format int32 */
  selectionRangeMax: number
  modifiers: FoodmaxapipbModifier[]
  relatedItemIDs: string[]
  /** @format int32 */
  availableStatus: number
  nameTranslation: FoodmaxapipbNilableTranslation
  isM41ItemLinked: boolean
  isFlexibleQuantityEnabled: boolean
  /** @format int32 */
  maxModifierSelectionQuantity: number
}

export interface FoodmaxapipbModifierGroupInOrderV2 {
  modifierGroupID: string
  modifierGroupName: string
  modifiers: FoodmaxapipbModifierInOrderV2[]
}

export interface FoodmaxapipbModifierInOrderV2 {
  modifierID: string
  modifierName: string
  priceDisplay: string
  /** @format int32 */
  quantity: number
  revampedPriceDisplay: string
  /**
   * 0 no changes
   * 1 added
   * 2 updated
   * 3 deleted
   * @format int32
   */
  editedStatus: number
}

export interface FoodmaxapipbMpaDetail {
  paymentArrangementType: string
  installmentConfig: FoodmaxapipbMpaInstallmentConfiguration
  rentalConfig: FoodmaxapipbMpaRentalConfiguration
  merchantID: string
}

export interface FoodmaxapipbMpaInstallmentConfiguration {
  /** @format int32 */
  frequency: number
  /** @format int32 */
  numberOfInstallments: number
}

export interface FoodmaxapipbMpaRentalConfiguration {
  /** @format int32 */
  frequency: number
  /** @format int64 */
  rentalAmountInMinorUnit: number
}

export interface FoodmaxapipbMssBasketCondition {
  scope: FoodmaxapipbMssScope
  basketConditionType: FoodmaxapipbBasketConditionType
  /** @format float */
  amountValue: number
  amountValueDisplay: string
  /** @format float */
  quantityValue: number
}

export interface FoodmaxapipbMssCondition {
  eaterType: FoodmaxapipbPromotionEaterType
  basketConditions: FoodmaxapipbMssBasketCondition[]
  allWeekdays: boolean
  weekDays: FoodmaxapipbWeekDays
  isOpenOnAllOpeningDays: boolean
}

export interface FoodmaxapipbMssScope {
  scopeType: FoodmaxapipbScopeType
  promoObjects: FoodmaxapipbPromotionObject[]
}

export interface FoodmaxapipbMultiPicsSetting {
  enable: boolean
  /** @format int32 */
  maxSize: number
}

export interface FoodmaxapipbNewItemSuggestion {
  newItem: FoodmaxapipbItemV2
  categoryName: string
  recommendationID: string
  recommendationReason: string
}

export interface FoodmaxapipbNilableBool {
  value: boolean
}

export interface FoodmaxapipbNilableTranslation {
  translation: Record<string, string>
  originalTranslationFromDS: Record<string, string>
}

export interface FoodmaxapipbNotificationEntity {
  notificationType: string
  message: FoodmaxapipbNotificationMessage
  payload: FoodmaxapipbNotificationPayload[]
}

export interface FoodmaxapipbNotificationMessage {
  title: string
  body: string
  sound: string
}

export interface FoodmaxapipbNotificationPayload {
  kind: string
  key: string
  value: string
}

export interface FoodmaxapipbNudge {
  type: string
}

export interface FoodmaxapipbOpenStatusMeta {
  /** @format date-time */
  pauseEndingTime: string
  /** @format date-time */
  reopeningTime: string
  isPausedByCapacityReached: boolean
  /** @format int32 */
  currentBusyModePrepTime: number
  isMexBusyModeAutoChanged: boolean
  /** @format date-time */
  busyModeStartTime: string
  /** @format int64 */
  pauseDayCount: number
  /** @format date-time */
  openUntil: string
  /** @format date-time */
  closedUntil: string
  isOpen24Hours: boolean
  pauseCause: string
}

export interface FoodmaxapipbOpeningHoursPerDay {
  ranges: FoodmaxapipbTimeRange[]
}

export interface FoodmaxapipbOptInCampaignEventResponse {
  result: FoodmaxapipbCampaignEventActivityResult
}

export interface FoodmaxapipbOptOutCampaignEventResponse {
  result: FoodmaxapipbCampaignEventActivityResult
}

export interface FoodmaxapipbOrder {
  orderID: string
  driver: FoodmaxapipbDriverInOrder
  eater: FoodmaxapipbEaterInOrder
  itemInfo: FoodmaxapipbItemsInOrder
  fare: FoodmaxapipbFareInOrder
  times: FoodmaxapipbTimeInOrder
  state: string
  merchant: FoodmaxapipbMerchantInOrder
  deliveryTaskpoolStatus: string
  preparationTaskpoolStatus: string
  /** @format int64 */
  cancelCode: number
}

export interface FoodmaxapipbOrderChangeLog {
  title: string
  contents: string[]
}

export interface FoodmaxapipbOrderFlags {
  isGrabInitiatedSplitOrder: boolean
  isOPTPhase5Enabled: boolean
  isManualAcceptMode: boolean
  isTH5050Order: boolean
}

export interface FoodmaxapipbOrderInList {
  orderID: string
  displayID: string
  driver: FoodmaxapipbDriverInOrderList
  eater: FoodmaxapipbEaterInOrderList
  itemInfo: FoodmaxapipbItemsInOrderList
  times: FoodmaxapipbTimeInOrder
  state: string
  deliveryTaskpoolStatus: string
  preparationTaskpoolStatus: string
  scheduleOrderInfo: FoodmaxapipbScheduledOrderInfo
  /** @format int32 */
  geAllocationStatus: number
  /** @format date-time */
  busyModeOrderPickupTime: string
  /** @format int64 */
  orderFlags: number
  /** @format int64 */
  orderStatsFlags: number
  dineInInfo: FoodmaxapipbDineInInfo
  labels: FoodmaxapipbOrderLabels
  chatroomInfo: FoodmaxapipbChatroomInfo
  mcorInfo: FoodmaxapipbCorrectOrderReadyTimeInfo
  orderValue: string
  orderBookings: FoodmaxapipbBookingInOrderList[]
  preparationTaskID: string
  flags: FoodmaxapipbOrderFlags
  orderContentMessage: string
  orderContentMessageWithFormat: string
  mexOPT: FoodmaxapipbMexOPT
  replacementInfo: FoodmaxapipbReplacementInfo
  orderReadyPhotoDetail: FoodmaxapipbOrderReadyPhotoDetail
  th5050OrderDetail: FoodmaxapipbTH5050OrderDetail
  upcomingData: FoodmaxapipbUpcomingData
  miwiRisk: FoodmaxapipbMIWIRisk
}

export interface FoodmaxapipbOrderIncidents {
  hasError: boolean
  data: FoodmaxapipbmavIncident[]
}

export interface FoodmaxapipbOrderLabels {
  acceptedViaCall: boolean
  isRead: boolean
  isOrderEdited: boolean
  acceptedViaAA: boolean
  hasPromo: boolean
  isTakeawayOrder: boolean
  isDeliverByMex: boolean
  isBusyModeOrder: boolean
  /** @format int64 */
  printCount: number
  isGiftOrder: boolean
}

export interface FoodmaxapipbOrderLevelDiscount {
  discountType: string
  discountName: string
  discountAmountDisplay: string
  /** @format int64 */
  discountAmountValueInMin: number
  isNewPromotion: boolean
}

export interface FoodmaxapipbOrderMarkReadyConfig {
  /** @format int32 */
  displayUndoButtonPercent: number
  /** @format int32 */
  displayUndoButtonSeconds: number
  /** @format int32 */
  undoAnimationDurationInSeconds: number
  /** @format int32 */
  warnLeftTimeInSeconds: number
}

export interface FoodmaxapipbOrderReadyPhotoDetail {
  /** @format int64 */
  status: number
  proofImageURL: string
  actionTitle: string
  actionDescription: string
}

export interface FoodmaxapipbOrderRecovery {
  resolution: FoodmaxapipbRecoveryResolution
  isRecoveryAllowed: boolean
  recoveryOptions: FoodmaxapipbRecoveryOption[]
  settings: FoodmaxapipbRecoverySettings
}

export interface FoodmaxapipbOrderStampInfo {
  userConsentMsg: string
}

export interface FoodmaxapipbOrderStatement {
  ID: string
  currency: FoodmaxapipbCurrency
  /** @format int64 */
  orderEarningsInMinorUnit: number
  deliveryStatus: string
  /** @format date-time */
  createdAt: string
  bookingCode: string
  priceDisplay: string
  /** @format date-time */
  updatedAt: string
  displayID: string
  isAcceptedByAA: boolean
  hasPromo: boolean
  isTakeawayOrder: boolean
  isScheduledOrder: boolean
  isLargeOrder: boolean
  cancelledOriginalPriceDisplay: string
  cancelRole: string
  isOrderEdited: boolean
  payMerchant: boolean
  /** @format int64 */
  orderFlags: number
  linkedShortOrderID: string
  preparationTaskID: string
  isAdsMarketingAttributed: boolean
  isPaxNewCustomer: boolean
  isPreparationTaskDelayed: boolean
  /** @format int64 */
  preparationTaskDelayedByMin: number
  /** @format int32 */
  compensationStatus: number
  /** @format date-time */
  cancelledAt: string
  isTH5050Order: boolean
  chatroomInfo: FoodmaxapipbChatroomInfo
  orderRecoveryStatuses: string[]
}

export interface FoodmaxapipbOrderStats {
  /** @format int32 */
  unreadNumberInNew: number
  /** @format int32 */
  unreadAANumberInPrepare: number
  /** @format int32 */
  unreadViaCallNumberInPrepare: number
  /** @format int32 */
  numberInNew: number
  /** @format int32 */
  numberInPrepare: number
  /** @format int32 */
  numberInReady: number
  /** @format int32 */
  numberInDelivering: number
}

export interface FoodmaxapipbOrderV2 {
  orderID: string
  driver: FoodmaxapipbDriverInOrderV2
  eater: FoodmaxapipbEaterInOrderV2
  itemInfo: FoodmaxapipbItemsInOrderV2
  fare: FoodmaxapipbFareInOrderV2
  times: FoodmaxapipbTimeInOrder
  state: string
  /**
   * state enumeratation:
   * ALLOCATING
   * ORDER_IN_PREPARE
   * ODER_EXECUTING
   * COMPLETED
   * CANCELLED
   * FAILED
   */
  merchant: FoodmaxapipbMerchantInOrder
  deliveryTaskpoolStatus: string
  /**
   * delivery status enumeration:
   * NEW
   * ALLOCATING
   * REALLOCATING(not in delivery task state machine)
   * PICKING_UP
   * DRIVER_AT_STORE
   * ORDER_PLACED_ON_MERCHANT
   * PROOF_OF_PRUCHASE
   * FOOD_COLLECTED
   * DRIVER_ARRIVED
   * COMPLETED
   * CANCELLED
   * FAILED
   */
  preparationTaskpoolStatus: string
  /**
   * preparation status:
   * NEW
   * ACCEPTED
   * COMPLETED
   * CANCELLED
   * EXPIRED
   * REJECTED
   * @format int64
   */
  cancelCode: number
  displayID: string
  bookingCode: string
  paymentMethod: string
  acceptedViaCall: boolean
  acceptedViaAA: boolean
  acknowledgedForAA: boolean
  /** @format int32 */
  qsrModelType: number
  hasPromo: boolean
  receiptAdditionalInfo: FoodmaxapipbReceiptAdditionalInfo
  allowComplete: boolean
  isTakeawayOrder: boolean
  orderLevelDiscounts: FoodmaxapipbOrderLevelDiscount[]
  flags: OrderV2Flags
  scheduledOrderInfo: FoodmaxapipbScheduledOrderInfo
  isLargeOrder: boolean
  isEditable: boolean
  isOrderEdited: boolean
  isOrderWithFriends: boolean
  /** @format int64 */
  uneditableReason: number
  /** @format int64 */
  cutlery: number
  cancelBy: string
  cancelRole: string
  leadsGenData: FoodmaxapipbLeadsGenData
  isBusyModeOrder: boolean
  /** @format date-time */
  busyModeOrderPickupTime: string
  /** @format int32 */
  busyModeApproach: number
  payMerchant: boolean
  cancelledMsg: string
  /** @format int64 */
  orderFlags: number
  /** @format int64 */
  orderStatsFlags: number
  /** @format int64 */
  receiptFlags: number
  dineInInfo: FoodmaxapipbDineInInfo
  chatroomInfo: FoodmaxapipbChatroomInfo
  membershipID: string
  mcorInfo: FoodmaxapipbCorrectOrderReadyTimeInfo
  mexReimbursementInfo: FoodmaxapipbMerchantReimbursementInfo
  displayHighlights: FoodmaxapipbDisplayHighlights
  giftInfo: FoodmaxapipbGiftInfo
  orderBookings: FoodmaxapipbBookingInOrderV2[]
  incidents: FoodmaxapipbOrderIncidents
  voucherInfo: FoodmaxapipbVoucherInfo
  stampInfo: FoodmaxapipbOrderStampInfo
  mexOPT: FoodmaxapipbMexOPT
  replacementInfo: FoodmaxapipbReplacementInfo
  isEditableByPax: boolean
  preparationTaskID: string
  orderChangeLog: FoodmaxapipbOrderChangeLog
  isEditableByPaxV2: boolean
  reservationDeposit: FoodmaxapipbOrderLevelDiscount[]
  orderReadyPhotoDetail: FoodmaxapipbOrderReadyPhotoDetail
  th5050OrderDetail: FoodmaxapipbTH5050OrderDetail
  upcomingData: FoodmaxapipbUpcomingData
  recovery: FoodmaxapipbOrderRecovery
  mpaDetail: FoodmaxapipbMpaDetail
  mexSupplierCourierInfo: FoodmaxapipbMexSupplierCourierInfo
  orderHeaderMessages: FoodmaxapipbContentBlock[]
  eInvoiceCarrierDisplay: FoodmaxapipbEInvoiceCarrierDisplay
  eInvoiceCarrierSection: FoodmaxapipbEInvoiceCarrierSection
}

export interface FoodmaxapipbOutOfStockInstruction {
  instructionType: string
  highlightMessage: string
  itemReplacementID: string
}

export interface FoodmaxapipbOutOfStockInstructionV2 {
  title: string
  replacementItems: FoodmaxapipbReplacementItemInfo[]
}

export interface FoodmaxapipbOutletProfile {
  merchantGroupID: string
  merchantID: string
  outletID: string
  franchiseTag: string
  areaTag: string
  brandTag: string
  integration: string
  integrationStatus: string
  integrationMsg: string
  /** @format int32 */
  deliveryFeeInMinorUnit: number
  /** @format int64 */
  deliveryTime: number
  /** @format int32 */
  scheduleOrderSubmitOption: number
  /** @format int32 */
  mappingType: number
  partner: OutletProfilePartner
}

export interface FoodmaxapipbPhotoDetail {
  imageURL: string
  filePath: string
  status: string
  tag: string
  reasons: string[]
  appealLink: string
  moderationID: string
}

export interface FoodmaxapipbPhotoList {
  photos: FoodmaxapipbPhotoDetail[]
}

export interface FoodmaxapipbPickingUpETA {
  orderID: string
  /** @format int32 */
  eta: number
  location: CommonpbCoordinates
}

export interface FoodmaxapipbPlaceInEaterOrderV2 {
  address: string
  keywords: string
}

export interface FoodmaxapipbPosFeatureEnabled {
  isPosAvailabilityEnabled: boolean
  isPosIntegrationEnabled: boolean
}

export interface FoodmaxapipbPostMenuPredictionFeedbackRequest {
  predictionFeedback: FoodmaxapipbPredictionFeedback
}

export interface FoodmaxapipbPostPredictionFeedbackRequest {
  predictionFeedback: FoodmaxapipbPredictionFeedback
}

export interface FoodmaxapipbPredictionFeedback {
  predictionID: string
  suggestedDepartments: FoodmaxapipbSuggestedDepartment[]
  selectedDepartmentID: string
  selectedSubDepartmentID: string
  itemID: string
}

export interface FoodmaxapipbPredictions {
  isAlcohol: boolean
  isTobacco: boolean
}

export interface FoodmaxapipbPreviewCard {
  categoryName: string
  itemName: string
  itemPrice: string
  chatID: string
}

export interface FoodmaxapipbPriceRecommendation {
  /** @format int64 */
  min: number
  /** @format int64 */
  max: number
  source: string
}

export interface FoodmaxapipbProfile {
  store: FoodmaxapipbStoreProfile
  outlet: FoodmaxapipbOutletProfile
}

export interface FoodmaxapipbPromotion {
  promotionID: string
  name: string
  /** @format date-time */
  start: string
  /** @format date-time */
  end: string
  condition: FoodmaxapipbMssCondition
  discount: FoodmaxapipbAction
  status: FoodmaxapipbPromotionStatus
  message: string
}

/** @default "EATER_EVERYONE" */
export enum FoodmaxapipbPromotionEaterType {
  EATER_EVERYONE = "EATER_EVERYONE",
  EATER_NEW = "EATER_NEW",
}

export interface FoodmaxapipbPromotionMessage {
  cta: string
  headline: string
}

export interface FoodmaxapipbPromotionObject {
  ID: string
  name: string
}

/** @default "PROMOTION_UPCOMING" */
export enum FoodmaxapipbPromotionStatus {
  PROMOTION_UPCOMING = "PROMOTION_UPCOMING",
  PROMOTION_ONGOING = "PROMOTION_ONGOING",
  PROMOTION_ANY = "PROMOTION_ANY",
}

export interface FoodmaxapipbProofItemRequest {
  itemID: string
  proofImageURL: string
}

export interface FoodmaxapipbProofMenuGroupItemRequest {
  menuGroupID: string
  itemID: string
  proofImageURL: string
}

export interface FoodmaxapipbPublishMenuGroupRequest {
  menuGroupID: string
  linkedStoreIDs: string[]
}

export interface FoodmaxapipbPublishMenuGroupResponse {
  menuGroupID: string
}

export interface FoodmaxapipbPushSelfTroubleShootRequest {
  language: string
}

export interface FoodmaxapipbPushSelfTroubleShootResponse {
  messageID: string
  results: FoodmaxapipbPushSelfTroubleShootResult[]
}

export interface FoodmaxapipbPushSelfTroubleShootResult {
  target: string
  status: string
  messageID: string
  errMessage: string
}

export interface FoodmaxapipbQuota {
  /** @format int64 */
  totalRedemption: number
  /** @format int64 */
  dailyRedemption: number
  /** @format int64 */
  totalRedemptionPerUser: number
}

export interface FoodmaxapipbRating {
  itemID: string
  itemLabel: string
  itemSubLabel: string
  rating: string
}

export interface FoodmaxapipbRatingDistribution {
  /** @format int64 */
  score: number
  /** @format int64 */
  countPercentage: number
}

export interface FoodmaxapipbReceiptAdditionalInfo {
  supportFeatureFlags: Record<string, boolean>
  /** @format int64 */
  printedCount: number
}

export interface FoodmaxapipbRecommendDishPhotosForMexResponse {
  dishPhotoList: FoodmaxapipbDishPhotoForMex[]
}

export interface FoodmaxapipbRecoveryOption {
  type: string
  isEnabled: boolean
  content: FoodmaxapipbRecoveryOptionContent
}

export interface FoodmaxapipbRecoveryOptionContent {
  title: string
  desc: string
  iconUrl: string
  redirectUrl: string
}

export interface FoodmaxapipbRecoveryResolution {
  title: string
  desc: string
  iconUrl: string
}

export interface FoodmaxapipbRecoverySettings {
  /** @format int64 */
  maxRefundAmountInMin: number
  refundReceivingAccount: string
}

export interface FoodmaxapipbRedemptionLog {
  paxName: string
  /** @format date-time */
  lastTimeStamp: string
}

export interface FoodmaxapipbRedemptionLogResponse {
  redemptionLog: FoodmaxapipbRedemptionLog[]
}

export interface FoodmaxapipbRelevantCuisineCampaign {
  chainMerchantID: string
  categories: FoodmaxapipbCategory[]
}

export interface FoodmaxapipbReplacedItemInfo {
  originalItem: FoodmaxapipbItemInOrderV2
  status: string
  substitute: FoodmaxapipbItemInOrderV2
}

export interface FoodmaxapipbReplacementInfo {
  /** @format int64 */
  replacementFlowStatus: number
  /** @format date-time */
  replacementStartTime: string
  /** @format int64 */
  timeLimitInSec: number
  hasTimeExtended: boolean
  replacedItemInfo: FoodmaxapipbReplacedItemInfo[]
}

export interface FoodmaxapipbReplacementItemInfo {
  itemID: string
  name: string
  /** @format int32 */
  quantity: number
  image: string
  fare: FoodmaxapipbItemFareV2
  weight: FoodmaxapipbSizeAttribute
  barcode: string
  SKU: string
}

export interface FoodmaxapipbReportPhotoFalsePositiveRequest {
  taskID: string
  errorItems: string[]
}

export interface FoodmaxapipbReportReason {
  code: string
  content: string
}

export interface FoodmaxapipbResetMenuGroupRequest {
  menuGroupID: string
}

export interface FoodmaxapipbRestockSetting {
  freq: string
  localtime: string
  byDay: string[]
  /** @format date-time */
  nextRestockTime: string
  /** @format int32 */
  maxStock: number
}

export interface FoodmaxapipbReview {
  reviewID: string
  /** @format date-time */
  createdAt: string
  /** @format int64 */
  rating: number
  description: string
  orderID: string
  bookingCode: string
  eaterName: string
  isReportedBefore: boolean
  status: FoodmaxapipbReviewStatus
  orderedItems: string[]
  isNew: boolean
  /** @format date-time */
  reportedAt: string
  /** @format int32 */
  unreportableReason: number
  /** @format int32 */
  unreplyableReason: number
  reviewReplies: FoodmaxapipbReviewReply[]
  paxReviewImageUrls: string[]
  /** @format date-time */
  contentLastModifiedAt: string
  recommendedItems: string[]
  merchantName: string
  merchantID: string
  serviceType: string
  reviewAspects: FoodmaxapipbReviewAspect[]
  /** @format date-time */
  paxLastUpdatedAt: string
  shouldDisplaySeeTranslation: boolean
}

export interface FoodmaxapipbReviewAspect {
  aspectId: string
  aspectName: string
  /** @format int32 */
  rating: number
  source: FoodmaxapipbReviewAspectSource
  reason: string
}

/** @default "UNSPECIFIED" */
export enum FoodmaxapipbReviewAspectSource {
  UNSPECIFIED = "UNSPECIFIED",
  SELECTED_BY_PAX = "SELECTED_BY_PAX",
  DETECTED_FROM_REVIEW = "DETECTED_FROM_REVIEW",
}

export interface FoodmaxapipbReviewOrderChangesRequest {
  orderID: string
  items: FoodmaxapipbEditedItemInfo[]
  isSkipOOSCheck: boolean
}

export interface FoodmaxapipbReviewOrderChangesResponse {
  orderSignatureID: string
  removedItemIDs: string[]
  removedModifierIDs: string[]
  order: FoodmaxapipbOrderV2
}

export interface FoodmaxapipbReviewReply {
  replyID: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  description: string
  /** @format int32 */
  uneditableReason: number
  repliedBy: string
}

export interface FoodmaxapipbReviewReplyConfig {
  replyGuidelineUrl: string
  /** @format int32 */
  replyCharacterLimit: number
  /** @format int32 */
  editDurationLimitInHours: number
  /** @format int32 */
  replyPopUpCount: number
}

export interface FoodmaxapipbReviewReportConfig {
  reportPolicyLink: string
  /** @format int64 */
  expectedDayCount: number
  reportReasons: FoodmaxapipbReportReason[]
  /** @format int32 */
  listReviewMaxDayCount: number
  dineoutReviewReportReasons: FoodmaxapipbReportReason[]
}

/** @default "UNKNOWN" */
export enum FoodmaxapipbReviewStatus {
  UNKNOWN = "UNKNOWN",
  PUBLIC = "PUBLIC",
  REPORTED = "REPORTED",
  REMOVED = "REMOVED",
}

export interface FoodmaxapipbSOCTypePriceRanges {
  itemID: string
  socTypePriceRanges: Record<string, string>
}

export interface FoodmaxapipbSOCTypeTranslation {
  socTypeTranslation: Record<string, CatalogpbTranslation>
}

export interface FoodmaxapipbScanMenuPhotoRequest {
  filePaths: string[]
}

export interface FoodmaxapipbScanMenuPhotoResponse {
  parentTaskID: string
}

export interface FoodmaxapipbScheduledOrderInfo {
  isScheduledOrder: boolean
  /** @format date-time */
  expectedDeliveryTime: string
  /** @format date-time */
  pickupTime: string
}

export interface FoodmaxapipbScope {
  type: string
  items: FoodmaxapipbItemV2[]
  objects: FoodmaxapipbCampaignObject[]
}

/** @default "PROMOTION_SCOPE_ITEMS" */
export enum FoodmaxapipbScopeType {
  PROMOTION_SCOPE_ITEMS = "PROMOTION_SCOPE_ITEMS",
  PROMOTION_SCOPE_CATEGORY = "PROMOTION_SCOPE_CATEGORY",
  PROMOTION_SCOPE_ORDER = "PROMOTION_SCOPE_ORDER",
}

export interface FoodmaxapipbSearchCampaign {
  keywords: FoodmaxapipbKeyword[]
  deSelectedKeywords: FoodmaxapipbKeyword[]
  isAutomatedSearchKeyword: boolean
}

export interface FoodmaxapipbSearchDishPhotosForMexResponse {
  retrieveID: string
  /** @format int64 */
  totalCount: number
  dishPhotoList: FoodmaxapipbDishPhotoForMex[]
}

export interface FoodmaxapipbSearchHistoryOrdersResponse {
  highlightKey: string
  orders: FoodmaxapipbOrderStatement[]
  nextSearchToken: string
  hasMore: boolean
}

export interface FoodmaxapipbSearchItemCategoriesResponse {
  queryID: string
  highlightKey: string
  categories: FoodmaxapipbItemCategory[]
  sellingTimes: FoodmaxapipbSellingTime[]
}

export interface FoodmaxapipbSearchItemsResponse {
  items: FoodmaxapipbItemV2[]
  highlightKey: string
  queryID: string
  modifierGroups: FoodmaxapipbModifierGroup[]
}

export interface FoodmaxapipbSearchMenusForMexResponse {
  queryID: string
  highlightKey: string
  categories: FoodmaxapipbItemCategory[]
  items: FoodmaxapipbItemV2[]
  sellingTimes: FoodmaxapipbSellingTime[]
  modifierGroups: FoodmaxapipbModifierGroup[]
  resultCountMap: Record<string, number>
  m41SearchResult: FoodmaxapipbM41SearchResult
}

export interface FoodmaxapipbSearchOngoingOrdersResponse {
  highlightKey: string
  orders: FoodmaxapipbSimpleOrderV2[]
  pageType: string
  nextSearchToken: string
  hasMore: boolean
}

export interface FoodmaxapipbSection {
  sectionID: string
  merchantID: string
  name: string
  /** @format int32 */
  cmplxSortOrder: number
  status: string
  serviceHours: CommonpbHoursByWeekDay
  /** @format date-time */
  updatedAt: string
  /** @format date-time */
  createdAt: string
  externalID: string
}

export interface FoodmaxapipbSectionSortTo {
  sectionID: string
  sorts: FoodmaxapipbSortTo[]
}

/** @default "OTHER" */
export enum FoodmaxapipbSegmentType {
  OTHER = "OTHER",
  NEW_CUSTOMERS = "NEW_CUSTOMERS",
  REPEATED_CUSTOMERS = "REPEATED_CUSTOMERS",
  ALL_CUSTOMERS = "ALL_CUSTOMERS",
}

export interface FoodmaxapipbSelfServeAdhocReport {
  /** @format double */
  lifetimeSpend: number
  /** @format double */
  lifetimeIncrementalSales: number
  /** @format int64 */
  lifetimeIncrementalOrders: number
  /** @format double */
  lifetimeROI: number
  dayReports: FoodmaxapipbDayReport[]
  keywordReports: FoodmaxapipbKeywordReport[]
  categoryReports: FoodmaxapipbCategoryReport[]
  lifetimeSpendDisplay: string
  lifetimeIncrementalSalesDisplay: string
  deSelectedKeywordsReports: FoodmaxapipbKeywordReport[]
  /** @format int64 */
  lifetimeClicks: number
  nudges: FoodmaxapipbNudge[]
}

export interface FoodmaxapipbSelfServeCampaign {
  campaignID: string
  isActive: boolean
  campaignType: FoodmaxapipbSelfServeCampaignType
  foodPromotionID: string
  segmentType: FoodmaxapipbSegmentType
  imageURL: string
  /** @format double */
  budget: number
  /** @format double */
  costPerClick: number
  campaignTime: FoodmaxapipbCampaignTime
  relevantCuisineCampaign: FoodmaxapipbRelevantCuisineCampaign
  searchCampaign: FoodmaxapipbSearchCampaign
  bannerCampaign: FoodmaxapipbBannerCampaign
  cta: string
  headline: string
  advertiserName: string
  images: FoodmaxapipbImageAsset[]
  isSmartBid: boolean
}

export interface FoodmaxapipbSelfServeCampaignConfig {
  /** @format double */
  budgetStep: number
  costPerClick: FoodmaxapipbCostPerClick
  enableSearchCampaign: boolean
  currency: FoodmaxapipbCurrency
  /** @format double */
  minCampaignDailyBudget: number
  minCampaignDailyBudgetDisplay: string
  /** @format double */
  maxCampaignDailyBudget: number
  maxCampaignDailyBudgetDisplay: string
  /** @format double */
  maxCampaignLifetimeBudget: number
  maxCampaignLifetimeBudgetDisplay: string
  /** @format double */
  initialAdCredits: number
  /** @format double */
  outstandingAdCredits: number
  /** @format date-time */
  freeCreditsExpiryDate: string
  /** @format double */
  dailyAdvertiserBudget: number
  dailyAdvertiserBudgetDisplay: string
  initialAdCreditsDisplay: string
  outstandingAdCreditsDisplay: string
  /** @format double */
  minSpendForReporting: number
  /** @format double */
  campaignStartingBudget: number
  bannerThemes: FoodmaxapipbBannerThemes
  campaignTypeOrders: FoodmaxapipbSelfServeCampaignType[]
  bannerAdsDescription: SelfServeCampaignConfigAdsDescription
  searchAdsDescription: SelfServeCampaignConfigAdsDescription
  dynamicBidding: FoodmaxapipbDynamicBidding
  budgetRecommendations: number[]
  enableEditCampaign: boolean
  /** @format double */
  minROASForSearch: number
  /** @format double */
  minROASForBanner: number
  /** @format double */
  minStep: number
  enableNudge: boolean
  /** @format int64 */
  defaultCampaignDuration: number
  /** @format int64 */
  defaultLeastKeywords: number
  /** @format int64 */
  nudgeViewTimes: number
  /** @format int64 */
  nudgeNewKeywords: number
  /** @format int64 */
  nudgeReduceKeywords: number
  /** @format int64 */
  nudgeExtendDurationInXDays: number
  /** @format double */
  nudgeIncreaseBudgetRatio: number
  /** @format double */
  nudgeIncreaseBidRatio: number
  /** @format double */
  nudgeReduceBidRatio: number
  enableNudgeInBackend: boolean
  enableAutomatedSearchKeyword: boolean
  /** @format int64 */
  maxCampaignDuration: number
}

/** @default "ANY" */
export enum FoodmaxapipbSelfServeCampaignType {
  ANY = "ANY",
  BANNER = "BANNER",
  SEARCH_RESULTS = "SEARCH_RESULTS",
  RELEVANT_CUISINE = "RELEVANT_CUISINE",
}

export interface FoodmaxapipbSelfServeError {
  message: string
  reason: string
  target: string
}

export interface FoodmaxapipbSelfServeGrab {
  storeID: string
}

export interface FoodmaxapipbSelfServeMenu {
  isPushedToMerchant: boolean
  isSynced: boolean
}

export interface FoodmaxapipbSelfServePartner {
  ID: string
  name: string
  merchantID: string
  qsr: string
}

export interface FoodmaxapipbSellingTime {
  sellingTimeID: string
  merchantID: string
  name: string
  status: string
  serviceHours: CommonpbHoursByWeekDay
  /** @format date-time */
  updatedAt: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  startTime: string
  /** @format date-time */
  endTime: string
}

export interface FoodmaxapipbServiceBasedMenuConfig {
  characteristicStrategy: CatalogpbCharacteristicStrategy
  itemAdvancedPricingConfig: FoodmaxapipbAdvancedPricingConfig
  modifierAdvancedPricingConfig: FoodmaxapipbAdvancedPricingConfig
}

export interface FoodmaxapipbServiceCountryGroup {
  countryName: string
  services: number[]
}

export interface FoodmaxapipbServiceTypeInfo {
  /** @format int64 */
  value: number
  name: string
  displayName: string
}

export interface FoodmaxapipbSetNewOrderReadyTimeResponse {
  message: string
}

export interface FoodmaxapipbSimpleOrder {
  orderID: string
  driver: FoodmaxapipbDriverInOrderList
  eater: FoodmaxapipbEaterInOrderList
  itemInfo: FoodmaxapipbItemsInOrderList
  times: FoodmaxapipbTimeInOrder
  state: string
  fare: FoodmaxapipbFareInOrder
}

export interface FoodmaxapipbSimpleOrderV2 {
  orderID: string
  eater: FoodmaxapipbEaterInOrderList
  itemInfo: FoodmaxapipbItemsInOrderList
  times: FoodmaxapipbTimeInOrder
  state: string
  /**
   * state enumeratation:
   * ALLOCATING
   * ORDER_IN_PREPARE
   * ORDER_EXECUTING
   * COMPLETED
   * CANCELLED
   * FAILED
   */
  deliveryTaskpoolStatus: string
  /**
   * delivery status enumeration:
   * NEW
   * ALLOCATING
   * REALLOCATING(not in delivery task state machine)
   * PICKING_UP
   * DRIVER_AT_STORE
   * ORDER_PLACED_ON_MERCHANT
   * PROOF_OF_PRUCHASE
   * FOOD_COLLECTED
   * DRIVER_ARRIVED
   * COMPLETED
   * CANCELLED
   * FAILED
   */
  preparationTaskpoolStatus: string
  /**
   * preparation status:
   * NEW
   * ACCEPTED
   * COMPLETED
   * CANCELLED
   * EXPIRED
   * REJECTED
   */
  displayID: string
  bookingCode: string
  acceptedViaCall: boolean
  isRead: boolean
  acceptedViaAA: boolean
  acknowledgedForAA: boolean
  hasPromo: boolean
  isTakeawayOrder: boolean
  scheduleOrderInfo: FoodmaxapipbScheduledOrderInfo
  isLargeOrder: boolean
  isOrderEdited: boolean
  /**
   * GE FulFill
   * @format int32
   */
  geAllocationStatus: number
  isDeliverByMex: boolean
  /** BusyMode Order Infos */
  isBusyModeOrder: boolean
  /**
   * busyModeOrderPickupTime = mexInputFoodPrepareTime +  OrderPlaceTime
   * @format date-time
   */
  busyModeOrderPickupTime: string
  driver: FoodmaxapipbDriverInOrderList
  /** @format int64 */
  orderFlags: number
  /** @format int64 */
  orderStatsFlags: number
  paymentMethod: string
  dineInInfo: FoodmaxapipbDineInInfo
  leadsGenData: FoodmaxapipbLeadsGenData
  chatroomInfo: FoodmaxapipbChatroomInfo
  mcorInfo: FoodmaxapipbCorrectOrderReadyTimeInfo
  orderValue: string
  /** @format int64 */
  printCount: number
  isGiftOrder: boolean
  orderBookings: FoodmaxapipbBookingInOrderList[]
  preparationTaskID: string
  flags: FoodmaxapipbOrderFlags
  mexOPT: FoodmaxapipbMexOPT
  replacementInfo: FoodmaxapipbReplacementInfo
  orderReadyPhotoDetail: FoodmaxapipbOrderReadyPhotoDetail
  th5050OrderDetail: FoodmaxapipbTH5050OrderDetail
  upcomingData: FoodmaxapipbUpcomingData
  miwiRisk: FoodmaxapipbMIWIRisk
}

export interface FoodmaxapipbSizeAttribute {
  unit: string
  /** @format float */
  value: number
  /** @format int32 */
  count: number
  /** @format float */
  originalValue: number
}

export interface FoodmaxapipbSortTo {
  resourceID: string
  /** @format int32 */
  sortOrder: number
}

/** @default "default" */
export enum FoodmaxapipbSortType {
  Default = "default",
  Asc = "asc",
  Desc = "desc",
}

export interface FoodmaxapipbSpecialItemSetting {
  specialItemType: string
  enablePromo: boolean
  enableCampaign: boolean
  enableMerchantMenuEditor: boolean
  editableFields: string[]
}

export interface FoodmaxapipbStatusDisplayInfo {
  statusLabel: string
  statusColor: string
  backgroundColor: string
  textColor: string
  subTextColor: string
  statusContent: string
}

export interface FoodmaxapipbStoreFrontSettings {
  IsLeadsGenMerchant: boolean
  IsEnableLeadsGenFulfill: boolean
}

export interface FoodmaxapipbStoreLocation {
  coordinates: CommonpbCoordinates
  address: string
  postcode: string
  /** @format int64 */
  countryID: number
  cityName: string
  /** @format int64 */
  cityID: number
  registeredCoordinates: CommonpbCoordinates
}

export interface FoodmaxapipbStorePIC {
  outletEmail: string
  outletPhone: string
}

export interface FoodmaxapipbStorePhoto {
  url: string
  type: string
  /** @format date-time */
  createdAt: string
}

export interface FoodmaxapipbStoreProfile {
  storeID: string
  storePIC: FoodmaxapipbStorePIC
  storeLocation: FoodmaxapipbStoreLocation
  storeName: string
  status: string
  secondaryStatus: string
  grabPayGrabID: string
  invoiceEmail: string
  contractPhone: string
}

export interface FoodmaxapipbSubmitOrderChangesRequest {
  orderSignatureID: string
  orderID: string
}

export interface FoodmaxapipbSuggestedDepartment {
  departmentID: string
  departmentName: string
  /** @format double */
  departmentConfidence: number
  subDepartmentID: string
  subDepartmentName: string
  /** @format double */
  subDepartmentConfidence: number
}

export interface FoodmaxapipbSwitchUserStoreRequest {
  userProfileGrabID: string
  storeID: string
  /** @format int64 */
  parentEntityType: number
  sessionID: string
  previousStoreID: string
}

export interface FoodmaxapipbTH5050OrderDetail {
  mexAcceptedOnTNApp: boolean
  tnAppDeepLink: string
}

export interface FoodmaxapipbTerminateCampaignEventResponse {
  result: FoodmaxapipbCampaignEventActivityResult
}

export interface FoodmaxapipbTime {
  /** @format uint64 */
  hour: number
  /** @format uint64 */
  minute: number
}

export interface FoodmaxapipbTimeAdjustmentOPT {
  /** @format int32 */
  minimumOPT: number
  /** @format int32 */
  maximumOPT: number
  /** @format int32 */
  maximumAdditionOPT: number
  /** @format int32 */
  maximumSubtractionOPT: number
}

export interface FoodmaxapipbTimeInOrder {
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  deliveredAt: string
  /** @format date-time */
  completedAt: string
  /** @format date-time */
  expiredAt: string
  /** @format date-time */
  acceptedAt: string
  /** @format date-time */
  cancelledAt: string
  /** @format date-time */
  readyAt: string
  /** @format date-time */
  displayedAt: string
  /** @format date-time */
  driverArriveRestoAt: string
  /** @format date-time */
  preparationCompletedAt: string
}

export interface FoodmaxapipbTimeRange {
  start: string
  end: string
}

export interface FoodmaxapipbTimeSlot {
  startTime: FoodmaxapipbTime
  endTime: FoodmaxapipbTime
}

export interface FoodmaxapipbTranslationMetadata {
  /** used by models that support scores, such as POI model (for merchant name translation) - false by default */
  isLowScore: boolean
}

/** @default "none" */
export enum FoodmaxapipbTrendingType {
  None = "none",
  Similarmex = "similarmex",
  Grabfood = "grabfood",
}

export interface FoodmaxapipbTrialCommission {
  /** @format date-time */
  startTime: string
  /** @format date-time */
  endTime: string
  /** @format float */
  commissionRate: number
}

export interface FoodmaxapipbUnlinkStoresFromMenuGroupRequest {
  menuGroupID: string
  storeIDs: string[]
}

export interface FoodmaxapipbUnlinkStoresFromMenuGroupResponse {
  menuGroupID: string
}

export interface FoodmaxapipbUpcomingData {
  /** @format date-time */
  estimatedPickUpTime: string
}

export interface FoodmaxapipbUpcomingFestive {
  festiveID: string
  name: string
  startDate: string
  endDate: string
  festivePromptContent: FoodmaxapipbFestivePromptContent
}

export interface FoodmaxapipbUpdateAutoCallPhoneV2Request {
  countryCode: string
  phoneNumber: string
}

export interface FoodmaxapipbUpdateAutoCallToggleRequest {
  isAutoCallEnabled: boolean
}

export interface FoodmaxapipbUpdateCallAgainToggleV2Request {
  callAgainAfterFailed: boolean
}

export interface FoodmaxapipbUpdateCampaignRequest {
  campaignID: string
  config: FoodmaxapipbCampaignConfig
}

export interface FoodmaxapipbUpdateCategoriesSortOrderRequest {
  sectionSorts: FoodmaxapipbSectionSortTo[]
}

export interface FoodmaxapipbUpdateCategoryRequest {
  categoryID: string
  name: string
  nameTranslation: FoodmaxapipbNilableTranslation
}

export interface FoodmaxapipbUpdateCategoryV3Request {
  categoryID: string
  name: string
  sellingTimeID: string
  nameTranslation: FoodmaxapipbNilableTranslation
}

export interface FoodmaxapipbUpdateClosePeriodEligibilityError {
  reasons: string[]
  /** @format int64 */
  orderCount: number
  /** @format int64 */
  scheduledOrderCount: number
}

export interface FoodmaxapipbUpdateDepartmentItemsSortOrderRequest {
  departmentID: string
  sorts: FoodmaxapipbSortTo[]
}

export interface FoodmaxapipbUpdateDepartmentRequest {
  departmentID: string
  sellingTimeID: string
}

export interface FoodmaxapipbUpdateDepartmentSortOrderRequest {
  parentDepartmentID: string
  sorts: FoodmaxapipbSortTo[]
}

export interface FoodmaxapipbUpdateDineInOpeningHoursEligibilityError {
  reasons: string[]
}

export interface FoodmaxapipbUpdateItemAvailableStatusV2Response {
  items: FoodmaxapipbItemV2[]
}

export interface FoodmaxapipbUpdateItemRequest {
  itemID: string
  item: FoodmaxapipbItemV2
  categoryID: string
  itemIDs: string[]
  /** @format int32 */
  availableStatus: number
  createAttributes: FoodmaxapipbItemAttributeValue[]
  deleteAttributes: FoodmaxapipbItemAttributeValue[]
  newAttributes: FoodmaxapipbItemAttributeValue[]
  categoryIDs: string[]
  departmentIDs: string[]
  subDepartmentIDs: string[]
  excludedItemIDs: string[]
  excludedSubDepartmentIDs: string[]
}

export interface FoodmaxapipbUpdateItemsSortOrderRequest {
  categoryID: string
  sorts: FoodmaxapipbSortTo[]
}

export interface FoodmaxapipbUpdateMenuEntitiesSortOrderRequest {
  parentEntityID: string
  /** @format int32 */
  parentEntityType: number
  sorts: FoodmaxapipbSortTo[]
  /** @format int32 */
  sortToEntityType: number
}

export interface FoodmaxapipbUpdateMenuEntityAvailableStatusResponse {
  task_id: string
  /** @format int64 */
  expired_at: number
}

export interface FoodmaxapipbUpdateMenuGroupCategoriesSortOrderRequest {
  menuGroupID: string
  sectionSorts: FoodmaxapipbSectionSortTo[]
}

export interface FoodmaxapipbUpdateMenuGroupCategoryRequest {
  menuGroupID: string
  categoryID: string
  name: string
  nameTranslation: FoodmaxapipbNilableTranslation
}

export interface FoodmaxapipbUpdateMenuGroupCategoryV2Request {
  menuGroupID: string
  categoryID: string
  name: string
  sellingTimeID: string
  nameTranslation: FoodmaxapipbNilableTranslation
}

export interface FoodmaxapipbUpdateMenuGroupDepartmentItemsSortOrderRequest {
  menuGroupID: string
  departmentID: string
  sorts: FoodmaxapipbSortTo[]
}

export interface FoodmaxapipbUpdateMenuGroupDepartmentRequest {
  menuGroupID: string
  departmentID: string
  sellingTimeID: string
}

export interface FoodmaxapipbUpdateMenuGroupDepartmentSortOrderRequest {
  menuGroupID: string
  parentDepartmentID: string
  sorts: FoodmaxapipbSortTo[]
}

export interface FoodmaxapipbUpdateMenuGroupItemRequest {
  menuGroupID: string
  itemID: string
  item: FoodmaxapipbItemV2
  categoryID: string
  itemIDs: string[]
  createAttributes: FoodmaxapipbItemAttributeValue[]
  deleteAttributes: FoodmaxapipbItemAttributeValue[]
  newAttributes: FoodmaxapipbItemAttributeValue[]
}

export interface FoodmaxapipbUpdateMenuGroupItemsSortOrderRequest {
  menuGroupID: string
  categoryID: string
  sorts: FoodmaxapipbSortTo[]
}

export interface FoodmaxapipbUpdateMenuGroupMenuEntitiesSortOrderRequest {
  parentEntityID: string
  /** @format int32 */
  parentEntityType: number
  sorts: FoodmaxapipbSortTo[]
  /** @format int32 */
  sortToEntityType: number
  menuGroupID: string
}

export interface FoodmaxapipbUpdateMenuGroupModifierGroupRequest {
  menuGroupID: string
  modifierGroupID: string
  modifierGroup: FoodmaxapipbModifierGroup
}

export interface FoodmaxapipbUpdateMenuGroupMultiSectionsRequest {
  sections: FoodmaxapipbMenuGroupSection[]
  sectionIDsToApprove: string[]
  sectionIDsToReactivate: string[]
  menuGroupID: string
}

export interface FoodmaxapipbUpdateMenuGroupRequest {
  menuGroupID: string
  name: string
  languageSettings: FoodmaxapipbMenuGroupLangSettings
}

export interface FoodmaxapipbUpdateMerchantBusyModeStatusRequest {
  /** @format int32 */
  option: number
  /** @format int32 */
  busyModeFoodPrepareTime: number
  /** @format date-time */
  busyModeStartTime: string
  source: string
}

export interface FoodmaxapipbUpdateMerchantClosePeriodV2Response {
  merchant: FoodmaxapipbMerchant
  eligibilityError: FoodmaxapipbUpdateClosePeriodEligibilityError
}

export interface FoodmaxapipbUpdateMerchantDailyCheckInSettingRequest {
  merchantID: string
  checkInOption: FoodmaxapipbCheckInOption
}

export interface FoodmaxapipbUpdateMerchantDailyCheckInSettingResponse {
  checkInStage: FoodmaxapipbCheckInStage
  haveCheckedIn: boolean
  /** @format date-time */
  nextOpenTime: string
}

export interface FoodmaxapipbUpdateMerchantDineInOpeningHoursResponse {
  eligibilityError: FoodmaxapipbUpdateDineInOpeningHoursEligibilityError
}

export interface FoodmaxapipbUpdateMerchantNameTranslationRequest {
  nameTranslation: FoodmaxapipbNilableTranslation
}

export interface FoodmaxapipbUpdateMerchantOpeningHoursResponse {
  eligibilityError: FoodmaxapipbUpdateOpeningHoursEligibilityError
}

export interface FoodmaxapipbUpdateMerchantPhotoExhibitionEligibilityError {
  reasons: string[]
}

export interface FoodmaxapipbUpdateMerchantPhotoExhibitionResponse {
  eligibilityError: FoodmaxapipbUpdateMerchantPhotoExhibitionEligibilityError
}

export interface FoodmaxapipbUpdateMerchantStatusResponse {
  isFirstStepSuccess: boolean
  isSecondStepSuccess: boolean
  eligibilityErr: FoodmaxapipbUpdateTempPauseStatusEligibilityErr
}

export interface FoodmaxapipbUpdateMerchantTempPauseStatusRequest {
  /** @format date-time */
  tempPauseEnd: string
  isUnpause: boolean
  allowOngoingGroupOrder: boolean
  reasonCode: string
  reasonText: string
}

export interface FoodmaxapipbUpdateMerchantTempPauseStatusResponse {
  eligibilityErr: FoodmaxapipbUpdateTempPauseStatusEligibilityErr
}

export interface FoodmaxapipbUpdateModifierAvailableStatusV2Response {
  modifiers: FoodmaxapipbModifier[]
}

export interface FoodmaxapipbUpdateModifierGroupRequest {
  modifierGroupID: string
  modifierGroup: FoodmaxapipbModifierGroup
}

export interface FoodmaxapipbUpdateModifierGroupsAvailableStatusRequest {
  modifierGroupIDs: string[]
  /** @format int32 */
  availableStatus: number
}

export interface FoodmaxapipbUpdateMultiSectionsRequest {
  sections: FoodmaxapipbSection[]
  sectionIDsToApprove: string[]
  sectionIDsToReactivate: string[]
}

export interface FoodmaxapipbUpdateOpeningHoursEligibilityError {
  reasons: string[]
  /** @format int64 */
  orderCount: number
  closeImmediately: boolean
  /** @format int64 */
  scheduledOrderCount: number
}

export interface FoodmaxapipbUpdatePasscodeRequest {
  oldPasscode: string
  newPasscode: string
}

export interface FoodmaxapipbUpdatePasscodeResponse {
  token: string
  /** @format date-time */
  unlockTime: string
  /** @format int32 */
  leftRetryTimes: number
  /** @format int32 */
  tokenExpireInSec: number
}

export interface FoodmaxapipbUpdatePhoneAndSwitchV2Request {
  countryCode: string
  phoneNumber: string
  isAutoCallEnabled: boolean
}

export interface FoodmaxapipbUpdateSpecialOpeningHoursEligibilityError {
  reasons: string[]
  /** @format int64 */
  orderCount: number
  /** @format int64 */
  scheduledOrderCount: number
  closeImmediately: boolean
}

export interface FoodmaxapipbUpdateSpecialOpeningHoursResponse {
  eligibilityError: FoodmaxapipbUpdateSpecialOpeningHoursEligibilityError
}

export interface FoodmaxapipbUpdateStoreProfileRequest {
  merchantID: string
  storeProfile: FoodmaxapipbStoreProfile
}

export interface FoodmaxapipbUpdateTempPauseStatusEligibilityErr {
  reasons: string[]
  /** @format int64 */
  scheduledOrderCount: number
  /** @format int64 */
  pendingAllocationOrderCount: number
}

export interface FoodmaxapipbUpdateVersionInfo {
  versionName: string
  packageName: string
  downloadURL: string
  updateContent: string
  updateContentLocale: Record<string, string>
  useGooglePlay: boolean
}

export interface FoodmaxapipbUploadFileMetadata {
  detection: FoodmaxapipbDetection
}

export interface FoodmaxapipbUploadFileRequest {
  file: FoodmaxapipbFileInfo
  category: string
  generatePresignedURL: boolean
}

export interface FoodmaxapipbUploadFileResponse {
  url: string
  metadata: FoodmaxapipbUploadFileMetadata
  token: string
  presignedURL: string
}

/** UploadImageRequest is the request object for UploadImage */
export interface FoodmaxapipbUploadImageRequest {
  image: string
  fileName: string
}

/** UploadImage is the repsonse object for UploadImage */
export interface FoodmaxapipbUploadImageResponse {
  imageURL: string
}

export interface FoodmaxapipbUploadMenuGroupFileRequest {
  file: FoodmaxapipbFileInfo
  category: string
  menuGroupID: string
}

export interface FoodmaxapipbUploadMenuScanDataResponse {
  /** @format int64 */
  succeededCategories: number
  /** @format int64 */
  succeededItems: number
  categories: FoodmaxapipbItemCategory[]
}

export interface FoodmaxapipbUpsertItemStockV1Request {
  itemID: string
  enableIms: boolean
  /** @format int32 */
  currentStock: number
  enableRestock: boolean
  restockSetting: FoodmaxapipbRestockSetting
}

export interface FoodmaxapipbUpsertItemV2Request {
  item: FoodmaxapipbItemV2
  categoryID: string
  itemAttributeValues: FoodmaxapipbItemAttributeValue[]
  extraParams: FoodmaxapipbItemUpsertExtraParams
}

export interface FoodmaxapipbUpsertItemV2Response {
  itemID: string
}

export interface FoodmaxapipbValidatePasscodeRequest {
  passcode: string
}

export interface FoodmaxapipbValidatePasscodeResponse {
  token: string
  /** @format date-time */
  unlockTime: string
  /** @format int32 */
  leftRetryTimes: number
  /** @format int32 */
  tokenExpireInSec: number
}

export interface FoodmaxapipbValidationError {
  error: Record<string, string>
}

export interface FoodmaxapipbVerifyMenuGroupTranslationRequest {
  entityType: string
  entityID: string
  nameTranslation: FoodmaxapipbNilableTranslation
  descriptionTranslation: FoodmaxapipbNilableTranslation
  menuGroupID: string
}

export interface FoodmaxapipbVerifyTranslationRequest {
  entityType: string
  entityID: string
  nameTranslation: FoodmaxapipbNilableTranslation
  descriptionTranslation: FoodmaxapipbNilableTranslation
}

export interface FoodmaxapipbVoucherInfo {
  externalID: string
}

export interface FoodmaxapipbWeekDays {
  monday: boolean
  tuesday: boolean
  wednesday: boolean
  thursday: boolean
  friday: boolean
  saturday: boolean
  sunday: boolean
}

export interface FoodmaxapipbWorkingTime {
  startTime: string
  endTime: string
  /** @format int64 */
  startWeekDay: number
  /** @format int64 */
  endWeekDay: number
  isWorking: boolean
  extendCEWorkingStartTime: string
  extendCEWorkingEndTime: string
}

export interface FoodmaxapipbmavActivity {
  appealable: boolean
  timeline: FoodmaxapipbmavTimeline[]
  /** @format int64 */
  appealWindow: number
  appealWindowDisplayMap: Record<string, string>
}

export interface FoodmaxapipbmavIncident {
  incidentID: string
  zendeskTicketID: string
  bookingCode: string
  orderID: string
  shortOrderNumber: string
  /** @format int64 */
  userID: number
  merchantID: string
  description: string
  imgURL: string[]
  /** @format int64 */
  zdStatus: number
  /** @format int64 */
  watchtowerStatus: number
  /** @format int64 */
  appeaseStatus: number
  /** @format int64 */
  appeaseAmount: number
  /** @format int64 */
  refundAmount: number
  appeaseCurrency: string
  /** @format date-time */
  appeaseTime: string
  /** @format date-time */
  refundTime: string
  /** @format int64 */
  appealStatus: number
  /** @format date-time */
  appealSentTime: string
  /** @format date-time */
  appealResultTime: string
  /** @format int64 */
  incidentMetric: number
  /** @format int64 */
  incidentGrouping: number
  /** @format int64 */
  incidentAlias: number
  /** @format int64 */
  incidentInput: number
  hasRead: boolean
  metadata: string
  /** @format date-time */
  incidentCreatedAt: string
  /** @format date-time */
  incidentClosedAt: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  /** @format int64 */
  chargebackStatus: number
  imageBase64: string[]
  /** @format int64 */
  mexVoucherStatus: number
  /** @format int64 */
  appealStatusTag: number
  incidentAffectItems: FoodmaxapipbIncidentAffectItem[]
}

export interface FoodmaxapipbmavIncidentDetail {
  /** @format int64 */
  ticketType: number
  /** @format int64 */
  count: number
}

export interface FoodmaxapipbmavTicketStats {
  /** @format int64 */
  totalCount: number
  details: FoodmaxapipbmavIncidentDetail[]
  additionalDetails: FoodmaxapipbmavIncidentDetail[]
}

export interface FoodmaxapipbmavTimeline {
  /** @format int64 */
  activityCode: number
  displayString: string
  /** @format date-time */
  contentTime: string
}

export interface KitRawJSON {
  Payload: string
}

export interface ProtobufAny {
  type_url: string
  /** @format byte */
  value: string
}

export interface RuntimeError {
  error: string
  /** @format int32 */
  code: number
  message: string
  details: ProtobufAny[]
}
